class AllFilters {
    constructor(page, elementIdPrefix) {
        this.page = page;
        this.elementIdPrefix = elementIdPrefix ?? '';
        this.generalFilters = new GeneralFilters(this.elementIdPrefix, this);
        this.rticFilters = new RticFilters(this.elementIdPrefix, this);
        this.companyFilters = new CompaniesFilter(this.elementIdPrefix, this);
        this.keywordFilters = new KeywordFilters("AND", "AND", this.elementIdPrefix, page, this);
        this.financialFilters = new FinancialFilters(this.elementIdPrefix, this);
        this.incorporationDateFilters = new IncorporationDateFilters(this.elementIdPrefix, this);
        this.innovationScoreFilter = new InnovationScoreFilter(this.elementIdPrefix, this);
        this.checkboxFilters = new BooleanFilters(this.elementIdPrefix, this);
        this.singleOptionFilters = new SingleOptionFilters(this.elementIdPrefix, this)
        this.storedFiltersCode = null;
    }

    getAllFilters(filtersLoadCallback, filtersLoadCallbackArgument) {
        let method, url, input;
        const filtersObject = this;

        method = "GET";
        url = `../api/filters/filters_actions.php?action=get_filters`;

        const getFiltersSuccess = function (response) {
            const responseParsed = JSON.parse(response);

            if (!responseParsed.filters || Object.keys(responseParsed.filters).length === 0)
                return serverIsDownMessage();

            coreFunctions.checkForDebugMessages(responseParsed);
            filtersObject.processRticFilters(responseParsed.filters);
            filtersObject.innovationScoreFilter.createSlider();
            filtersObject.singleOptionFilters.addFilters(responseParsed.filters);
            filtersObject.generalFilters.addAllFilters(responseParsed);
            filtersObject.filtersLoadComplete(filtersLoadCallback, filtersLoadCallbackArgument);
        }

        const getFiltersError = function () {
            console.log("Error retrieving filters");
            filtersObject.filtersLoadComplete(filtersLoadCallback, filtersLoadCallbackArgument);
        }

        coreFunctions.xhrHelper(method, url, getFiltersSuccess, getFiltersError, input);
    }

    processRticFilters(allFilters) {
        let allRticFilters, allCicFilters;
        const self = this;
        if (allRticFilters = allFilters.RTICs) {
            allRticFilters.forEach(rticFilter => {
                self.rticFilters.newRtic(rticFilter.code, rticFilter.name, rticFilter.activememberscount ?? rticFilter.memberscount, false, false).processRticVerticals(rticFilter.verticals, false);
            });

        }

        if ((allCicFilters = allFilters.CICs) && allCicFilters.length > 0) {
            allCicFilters.forEach(cicFilter => {
               self.rticFilters.newRtic(cicFilter.code, cicFilter.name, cicFilter.activememberscount ?? cicFilter.memberscount, false, true).processRticVerticals(cicFilter.verticals, true);
            });
        } else {
            document.querySelector(".controlHolder.filterControl[filtergroup='CICs']").classList.add("hidden"); // No CIC filters, hide the control element
        }

        if (allRticFilters.length > 0 || allCicFilters.length > 0) {
            this.rticFilters.addRticFiltersToPage();
        }
    }

    filtersLoadComplete(filtersLoadCallback, filtersLoadCallbackArgument) {
        filtersLoadCallback(filtersLoadCallbackArgument);
        return this;
    }

    getFiltersForSavedMlList() {
        return {
            useFiltersClass: true,
            activeFilters: this.getFiltersForSavedList()
        }
    }

    processSavedMlListFilters(filtersObject) {
        // Uses up-to-date filters structure
        if (filtersObject.useFiltersClass) {
            this.resetAllFilters().processAllStoredFilters(filtersObject.activeFilters);
        } else {
            this.processAllStoredFiltersLegacyVersion(filtersObject);
        }
        return this;
    }

    processAllStoredFiltersLegacyVersion(filtersObject) {
        let activeGeneralFilter, activeFinancialFilterElement;
        if (filtersObject) {
            if (filtersObject.filters) {
                for (var filter in filtersObject.filters) {
                    if (activeGeneralFilter = this.generalFilters.filters.find(filterObject => filterObject.legacyField == filter)) {
                        activeGeneralFilter.presetGeneralFilter(filtersObject.filters[filter]).filterSubgroupToggleClick().updateActiveFilterElementsTotal().addPresetStyleToFilterControl();
                    } else if (filter == "IncorporationDateFrom") {
                        this.incorporationDateFilters.presetYearFrom(filtersObject.filters[filter]);
                    } else if (filter == "IncorporationDateTo") {
                        this.incorporationDateFilters.presetYearTo(filtersObject.filters[filter]);
                    }
                }
            }
            if (filtersObject.keywordFilters && !Array.isArray(filtersObject.keywordFilters)) {
                this.keywordFilters.processStoredKeywords(filtersObject.keywordFilters).updateKeywordsTotal().addPresetStyleToFilterControl();
            }
            if (filtersObject.financialFilters) {
                for (var filter in filtersObject.financialFilters) {
                    if (activeFinancialFilterElement = document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .financialFiltersInput input[name="${filter}"]`)) {
                        this.financialFilters.presetFinancialFilter(activeFinancialFilterElement, filtersObject.financialFilters[filter]);
                    }
                }
            }
        }
    }

    getFiltersForSavedList() {
        const filtersForSavedList = {
            filters: {}
        };
        Object.assign(filtersForSavedList.filters, this.checkboxFilters.getActiveBooleanFilters());
        Object.assign(filtersForSavedList.filters, this.innovationScoreFilter.getInnovationScoreFilter());
        Object.assign(filtersForSavedList.filters, this.generalFilters.getActiveGeneralFilters());
        Object.assign(filtersForSavedList.filters, this.financialFilters.getActiveFinancialFilters());
        Object.assign(filtersForSavedList.filters, this.companyFilters.getActiveCompanyFilters());
        Object.assign(filtersForSavedList.filters, this.incorporationDateFilters.getActiveIncorporationDateFilters());
        Object.assign(filtersForSavedList.filters, this.rticFilters.getActiveRticFilters());
        Object.assign(filtersForSavedList, this.keywordFilters.getActiveKeywordFiltersForSavedList());
        Object.assign(filtersForSavedList.filters, this.singleOptionFilters.getActiveSingleOptionFilters());
        return filtersForSavedList;
    }

    getFiltersForSearch() {
        const filtersObject = {
            filters: {}
        };
        //Object.assign(filtersObject.filters, this.getFiltersForCompaniesNumberNameUrlSearch().filters);
        Object.assign(filtersObject.filters, this.checkboxFilters.getActiveBooleanFilters());
        Object.assign(filtersObject.filters, this.innovationScoreFilter.getInnovationScoreFilter());
        Object.assign(filtersObject.filters, this.generalFilters.getActiveGeneralFilters());
        Object.assign(filtersObject.filters, this.financialFilters.getActiveFinancialFilters());
        Object.assign(filtersObject.filters, this.companyFilters.getActiveCompanyFilters());
        Object.assign(filtersObject.filters, this.incorporationDateFilters.getActiveIncorporationDateFilters());
        Object.assign(filtersObject.filters, this.companyFilters.getManuallyIncludedAndExcludedCompanies());
        Object.assign(filtersObject.filters, this.rticFilters.getActiveRticFilters());
        Object.assign(filtersObject.filters, this.rticFilters.getUserCics());
        Object.assign(filtersObject.filters, this.keywordFilters.getActiveKeywordFilters());
        Object.assign(filtersObject.filters, this.singleOptionFilters.getActiveSingleOptionFilters());
        return filtersObject;
    }

    getHumanReadableFiltersRepresentation(startString) {
        let content = '';
        const formatter = new Intl.ListFormat("en-US", {
            style: 'long',
            type: 'conjunction',
        });
        const maxElementsInChunk = 5;

        const filterContentChunks = [].concat(this.incorporationDateFilters.getHumanReadableFilterChunk(), this.generalFilters.getHumanReadableFilterChunks(maxElementsInChunk), this.financialFilters.getHumanReadableFilterChunks(), this.innovationScoreFilter.getHumanReadableFilterChunk(), this.singleOptionFilters.getHumanReadableFilterChunks(), ...this.rticFilters.getHumanReadableFilterChunks(maxElementsInChunk), this.keywordFilters.getHumanReadableFilterChunk(), this.checkboxFilters.getHumanReadableFilterChunks());

        if (filterContentChunks.length > 0) {
            content = `${startString ?? "A list of companies"} ${formatter.format(filterContentChunks)}`
        }

        return content;
    }

    // Check which fields are on for filtering
    resultsFilteringActive() {
        const filtersToIgnore = ["UserCICs"];
        const activeFiltersObject = this.getFiltersForSearch();
        const activeFilterFields = Object.keys(activeFiltersObject.filters).filter(filter => !filtersToIgnore.includes(filter));
        return (activeFilterFields.length > 0);
    }

    saveFiltersState(filtersForSearch) {
        let storedFiltersCode, urlQuery;
        storedFiltersCode = coreFunctions.getRandomString(15);

        // Limit to size of local storage variables
        // TODO: Add condition here for include and exclude
        if (!filtersForSearch.filters.CompanyNumbers || filtersForSearch.filters.CompanyNumbers.length < 100000) {
            filtersForSearch.code = storedFiltersCode;
            this.storedFiltersCode = storedFiltersCode;
            // Store active filters
            localStorage.setItem("filters", JSON.stringify(filtersForSearch));
            if (this.page != "mlListPage") {
                urlQuery = `?filters_code=${storedFiltersCode}`;
                if (this.page == "explore") {
                    urlQuery += `&page=${explore.exploreLists.results.pageNumber}`;
                }
                window.history.replaceState('searchquery', 'searchqueryedit', urlQuery);
            }
        }

        return this;
    }

    discardPendingFilters() {
        this.resetAllFilters().checkForStoredFilters().resetFilterUpdateControls();

    }

    // Compare curently selected/active filters with the last filters update
    activeFiltersHaveChanged() {
        const storedFilters = this.getStoredFilters(); // Get filters of last run search
        const activeFilters = (this.getFiltersForSearch()).filters; // Get currently active search

        // Ignore some fields from check
        const fieldsToExcludeFromCheck = ['UserCICs', 'ManuallyInclude', 'ManuallyExclude'];
        fieldsToExcludeFromCheck.forEach(field => {
            delete activeFilters[field];
            delete storedFilters[field];
        });

        return !coreFunctions.objectsMatch(storedFilters, activeFilters);
    }

    checkForFiltersUpdate() {
        if (this.activeFiltersHaveChanged()) {
            this.filtersUpdateIsReady();
        } else {
            this.resetFilterUpdateControls();
        }
        return this;
    }

    filtersUpdateIsReady() {
        document.querySelectorAll(".update-filters").forEach(element => element.classList.add("update-ready"));
        return this;
    }

    resetFilterUpdateControls() {
        document.querySelectorAll(".update-filters").forEach(element => element.classList.remove("update-ready"));
        return this;
    }

    // Returns stored filters object from last run search
    getStoredFilters() {
        let storedFilters = {};
        if (this.page !== "compare" && typeof (Storage) !== "undefined") {
            let storedFiltersObject = localStorage.getItem("filters");
            if (storedFiltersObject) {
                storedFiltersObject = JSON.parse(storedFiltersObject);
                let storedFiltersCode = storedFiltersObject.code;
                let activeFiltersCode = this.storedFiltersCode;
                if (storedFiltersCode != null && activeFiltersCode != null && storedFiltersCode == activeFiltersCode) {
                    storedFilters = storedFiltersObject.filters;
                    // Check keyword filters state
                    if (storedFiltersObject.keywords) {
                        Object.assign(storedFilters, this.keywordFilters.processStoredKeywordsObject(storedFiltersObject.keywords));
                    }
                }
            }
        }
        return storedFilters;
    }

    checkForStoredFilters() {
        let storedCode, filtersCode, storedFiltersObject;
        storedFiltersObject = localStorage.getItem("filters");
        // Check browser support
        if (this.page !== "compare" && typeof (Storage) !== "undefined") {
            if (storedFiltersObject) {
                storedFiltersObject = JSON.parse(storedFiltersObject);
                storedCode = storedFiltersObject.code;
                filtersCode = coreFunctions.getQueryVariable("filters_code");
                if (storedCode == filtersCode) {
                    this.processAllStoredFilters(storedFiltersObject);
                }
            }
        }
        return this;
    }

    processAllStoredFilters(filtersObject) {
        if (filtersObject) {
            this.processStoredGeneralFilters(filtersObject.filters);
            if (filtersObject.keywords) {
                this.keywordFilters.processStoredKeywords(filtersObject.keywords).updateKeywordsTotal().addPresetStyleToFilterControl();
            }
            if (filtersObject.rtics) {
                this.rticFilters.processStoredRticFiltersLegacy(filtersObject.rtics);
            }
            this.singleOptionFilters.processStoredSingleOptionFilters(filtersObject.filters);
            // Remove any update controls when presetting filters
            this.resetFilterUpdateControls();
        }
        return this;
    }

    processStoredGeneralFilters(activeFilters) {
        let activeGeneralFilter, activeFinancialFilterElement, activeSingleOptionFilter;
        this.checkboxFilters.processStoredBooleanFilters(activeFilters);
        for (var filter in activeFilters) {
            // Company name filter
            if (filter == "CompanyName") {
                this.companyFilters.addStoredCompanyName(activeFilters[filter]);
            }
            // Company number filters
            else if (filter == "CompanyNumbers") {
                this.companyFilters.addStoredCompanyNumbers(activeFilters[filter]);
            }
            // Manual includes
            else if (filter == "ExploreManuallyInclude") {
                this.companyFilters.addStoredExploreIncludedCompanyNumbers(activeFilters[filter]);
            }
            // Manual excludes
            else if (filter == "ExploreManuallyExclude") {
                this.companyFilters.addStoredExploreExcludedCompanyNumbers(activeFilters[filter]);
            }
            // Postcode search move this over to new class
            else if (filter == "SearchPostcode") {
                this.generalFilters.filters.find(filter => filter.filter == "Postcodes").filterSubgroupToggleClick().setPostcodeSearchFilter(activeFilters[filter]).updateActiveFilterElementsTotal();
            }
            // Postcode search radius
            else if (filter == "SearchPostcodeRadius") {
                this.generalFilters.filters.find(filter => filter.filter == "Postcodes").filterSubgroupToggleClick().setPostcodeSearchRadiusFilter(activeFilters[filter]).updateActiveFilterElementsTotal();
            }
            // RTIC filters
            else if (filter == "SelectedRTICs") {
                this.rticFilters.processStoredRticFilters(activeFilters[filter]);
            }
            // General filters
            else if (activeGeneralFilter = this.generalFilters.filters.find(filterObject => filterObject.queryField == filter)) {
                activeGeneralFilter.presetGeneralFilter(activeFilters[filter]).filterSubgroupToggleClick().updateActiveFilterElementsTotal().addPresetStyleToFilterControl();
            }
            // Financial filters
            else if (activeFinancialFilterElement = document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .financialFiltersInput input[name="${filter}"]`)) {
                this.financialFilters.presetFinancialFilter(activeFinancialFilterElement, activeFilters[filter]);
            }
        }
    }

    resetFiltersButtonOnClick() {
        this.resetAllFilters();
        // Only show calculate results prompt if not already in filters window.
        if (!document.querySelector(".filterControlHolderVisible")) {
            this.checkForPendingFilterUpdates(true);
        }
    }

    resetAllFilters() {
        this.companyFilters.resetCompaniesFilter();
        this.financialFilters.resetFinancialFilters();
        this.keywordFilters.resetAllKeywords();
        this.incorporationDateFilters.resetIncorporationDateFilters();
        this.rticFilters.resetRticFilters();
        this.generalFilters.resetGeneralFilters();
        this.innovationScoreFilter.resetInnovationScoreFilter();
        this.checkboxFilters.resetBooleanFilters();
        this.singleOptionFilters.resetSingleOptionFilters();
        return this;
    }

    toggleFilterControls(element) {
        var filterHolder = element.closest(".trainingSetOptionsHolder");
        var filter = element.getAttribute("filtergroup");
        var filterControlHolder = filterHolder.querySelector(".filterControlHolder[filtergroup='" + filter + "']");
        var filterControlButton = filterHolder.querySelector(".filterControl[filtergroup='" + filter + "']");

        var timeout = 0;
        var existingActiveFilter = filterHolder.querySelector(".filterControlHolder.filterControlHolderVisible:not([filtergroup='" + filter + "'])");

        this.hideMobileHeaderControls(element);

        if (existingActiveFilter) {
            existingActiveFilter.classList.add("noTransition");
            filterControlHolder.classList.add("noTransition");
            existingActiveFilter.classList.remove("filterControlHolderVisible");
            var existingFilter = existingActiveFilter.getAttribute("filtergroup");
            filterHolder.querySelector(".filterControl.filterControlVisible[filtergroup='" + existingFilter + "']").classList.remove("filterControlVisible");
            timeout = 250;
        }

        if (filterControlHolder.classList.contains("filterControlHolderVisible")) {
            filterControlHolder.classList.remove("filterControlHolderVisible");
            filterControlButton.classList.remove("filterControlVisible");
            this.checkForPendingFilterUpdates(false);
        }
        // Filter controls inactive show filter tray
        else {
            filterControlHolder.classList.add("filterControlHolderVisible");
            filterControlButton.classList.add("filterControlVisible");
            // Mobile display, automatically scroll to element
            // if (getComputedStyle(document.querySelector(".headerMobileLabel")).display == "block") {
            //     filterControlHolder.scrollIntoView({behavior: "smooth"});
            // }
        }

        setTimeout(function () {
            if (existingActiveFilter) {
                existingActiveFilter.classList.remove("noTransition");
            }
            filterControlHolder.classList.remove("noTransition");
        }, 250);

    }

    checkForPendingFilterUpdates(filtersReset) {
        if (document.querySelector(".update-filters.update-ready") && this.page != "compare") {
            if (filtersReset) {
                coreFunctions.showOverlay("filters-reset");
            } else {
                coreFunctions.showOverlay("filters-update");
            }

        }
        return this;
    }

    toggleMobileHeaderControls(element) {
        var headerControls = element.closest(".trainingSetHeaderBar");
        if (headerControls) {
            if (headerControls.classList.contains("mobileControlsVisible")) {
                headerControls.classList.remove("mobileControlsVisible");
            } else {
                headerControls.classList.add("mobileControlsVisible");
            }
        }
    }

    // Hide filter controls in mobile view
    hideMobileHeaderControls(element) {
        let headerBar;
        if (headerBar = element.closest(".trainingSetHeaderBar")) {
            element.closest(".trainingSetHeaderBar").classList.remove("mobileControlsVisible");
        }
    }

    // Legacy method where company search box was separate from the main filter
    getFiltersForCompaniesNumberNameUrlSearch() {
        let filtersObject = {};
        if (document.getElementById("companyNumberNameUrlInput") && document.getElementById("companyNumberNameUrlInput").value) {
            filtersObject = {
                filters: {
                    Skip: 0,
                    CompanyName: document.getElementById("companyNumberNameUrlInput").value.trim()
                }
            };
            Object.assign(filtersObject.filters, this.companyFilters.getManuallyIncludedAndExcludedCompanies());
            Object.assign(filtersObject.filters, this.rticFilters.getUserCics());
        }
        return filtersObject;
    }

    hideFilterControls() {
        let activeFilterControl;
        this.resetFilterUpdateControls();
        if (activeFilterControl = document.querySelector(".filterControl.filterControlVisible")) {
            this.toggleFilterControls(activeFilterControl);
        }
        return this;
    }
}

class IncorporationDateFilters {
    constructor(elementIdPrefix, parent) {
        this.incorporationDateFrom = null;
        this.incorporationDateTo = null;
        this.incorporationYearFrom = null;
        this.incorporationYearTo = null;
        this.datesValid = false;
        this.filter = "incorporation";
        this.filterGroup = "company_growth";
        this.elementIdPrefix = elementIdPrefix;
        this.parent = parent;
    }

    checkIncorporationDateFilterValid() {
        if (this.incorporationYearFrom && this.incorporationYearTo && this.incorporationYearTo < this.incorporationYearFrom) {
            this.datesValid = false;
        } else if (this.incorporationYearTo && !this.incorporationYearFrom) {
            this.datesValid = false;
        } else {
            this.datesValid = true;
        }
        return this;
    }

    incorporationDateFromChange(value) {
        this.incorporationDateFrom = `${value}-01-01`;
        this.incorporationYearFrom = Number(value);
        this.checkIncorporationDateFilterValid();
        if (this.datesValid == true) {
            this.incorporationDateFilterValid();
        } else {
            this.incorporationDateFilterInvalid("The start year most be before the end year");
        }
        return this;
    }

    incorporationDateToChange(value) {
        this.incorporationDateTo = `${value}-12-31`;
        this.incorporationYearTo = Number(value);
        this.checkIncorporationDateFilterValid();
        if (this.datesValid == true) {
            this.incorporationDateFilterValid();
        } else {
            if (!this.incorporationYearFrom) {
                this.incorporationDateFilterInvalid("Now please select a start year");
            } else {
                this.incorporationDateFilterInvalid("The end year most be after the start year");
            }
        }
        return this;
    }

    incorporationDateFilterValid() {
        document.getElementById(this.elementIdPrefix + "incorporationDateFilterValidationError").classList.remove("incorporationDateInvalid");
        this.updateIncorporationDateSummary();
        return this;
    }

    incorporationDateFilterInvalid(validationMessage) {
        document.getElementById(this.elementIdPrefix + "incorporationDateFilterValidationError").innerHTML = validationMessage;
        document.getElementById(this.elementIdPrefix + "incorporationDateFilterValidationError").classList.add("incorporationDateInvalid");
        this.updateIncorporationDateSummary();
        return this;
    }

    updateIncorporationDateSummary() {
        // if (this.datesValid == true) {
        //     document.querySelector(".filterControl[filtergroup='foundingyear'] .total").innerHTML = ((!this.incorporationYearFrom) ? "" : ((this.incorporationYearFrom == 1000) ? "Pre 1900" : this.incorporationYearFrom)) + "-" + ((!this.incorporationYearTo) ? "" : this.formatYearTo());
        // } else {
        //     document.querySelector(".filterControl[filtergroup='foundingyear'] .total").innerHTML = "-";
        // }
        let element = document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .combinedFiltersTotal[data-filtergroup='${this.filterGroup}']`);
        // Filter is on or off
        element.dataset[`filterstatus_${this.filter}`] = (this.filterIsActive()) ? 1 : 0;
        // Combine filters into total for the filter group. Value is linked to total attribute
        element.dataset.total = Object.entries(element.dataset).reduce((accumalator, entry) => accumalator + ((entry[0].startsWith('filterstatus')) ? Number(entry[1]) : 0), 0);
        this.removePresetStyleFromFilterControl();
        this.parent.checkForFiltersUpdate();
        return this;
    }

    filterIsActive() {
        return this.datesValid === true;
    }

    formatYearTo() {
        let yearFromSubstring, yearToSubstring;
        yearFromSubstring = this.incorporationYearFrom.toString().substring(0, 2);
        yearToSubstring  = this.incorporationYearTo.toString().substring(0, 2);
        return (yearFromSubstring == yearToSubstring) ? this.incorporationYearTo.toString().substring(2, 4) : this.incorporationYearTo;
    }

    resetIncorporationDateFilters() {
        document.getElementById(this.elementIdPrefix + "incorporationDateFromSelect").value = "off";
        document.getElementById(this.elementIdPrefix + "incorporationDateToSelect").value = "off";
        document.getElementById(this.elementIdPrefix + "incorporationDateFilterValidationError").classList.remove("incorporationDateInvalid");
        this.incorporationDateFrom = null;
        this.incorporationDateTo = null;
        this.incorporationYearFrom = null;
        this.incorporationYearTo = null;
        this.datesValid = false;
        this.updateIncorporationDateSummary();
        return this;
    }

    getActiveIncorporationDateFilters() {
        const activeIncorporationDateFilters = {};
        if (this.datesValid == true) {
            if (this.incorporationDateFrom) {
                activeIncorporationDateFilters.IncorporationDateFrom = this.incorporationDateFrom;
            }
            if (this.incorporationDateTo) {
                activeIncorporationDateFilters.IncorporationDateTo = this.incorporationDateTo;
            }
            return activeIncorporationDateFilters;
        } else {
            return false;
        }
    }


    getHumanReadableFilterChunk() {
        let chunk = [];
        if (this.datesValid == true) {
            let fromYear = this.getYear(this.incorporationDateFrom);
            let toYear = this.getYear(this.incorporationDateTo);
            if (fromYear && toYear) {
                chunk.push(`founded between ${fromYear} and ${toYear}`);
            } else if (fromYear) {
                chunk.push(`founded since ${fromYear}`);
            } else if (toYear) {
                chunk.push(`founded before ${toYear}`);
            }
        }
        return chunk;
    }

    getYear(date) {
        return (date) ? new Date(date).getFullYear() : null;
    }

    presetYearFrom(dateFrom) {
        let yearFrom = dateFrom.split("-")[0];
        if (document.querySelector(`#${this.elementIdPrefix}incorporationDateFromSelect option[value='${yearFrom}']`)) {
            document.getElementById(this.elementIdPrefix + "incorporationDateFromSelect").value = yearFrom;
            this.incorporationDateFromChange(yearFrom).addPresetStyleToFilterControl();
        }
        return this;
    }

    presetYearTo(dateTo) {
        let yearTo = dateTo.split("-")[0];
        if (document.querySelector(`#${this.elementIdPrefix}incorporationDateToSelect option[value='${yearTo}']`)) {
            document.getElementById(this.elementIdPrefix + "incorporationDateToSelect").value = yearTo;
            this.incorporationDateToChange(yearTo).addPresetStyleToFilterControl();
        }
        return this;
    }

    addPresetStyleToFilterControl() {
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControl[filtergroup='${this.filterGroup}']`).classList.add("filterPreset");
        return this;
    }

    removePresetStyleFromFilterControl() {
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControl[filtergroup='${this.filterGroup}']`).classList.remove("filterPreset");
        return this;
    }

}

class RticFilters {
    constructor(elementIdPrefix, parent) {
        this.filters = [];
        this.elementIdPrefix = elementIdPrefix;
        this.parent = parent;
    }

    getHumanReadableFilterChunks(maxElementsInChunk) {
        const activeFilters = this.filters.filter(filter => filter.rticFilterIsActive());
        const cicChunks = [];
        const rticChunks = [];
        activeFilters.forEach(filter => (filter.cic ? cicChunks : rticChunks).push(filter.getHumanReadableFilterChunk(maxElementsInChunk)));

        return [this.formatHumanReadableFilterChunk(cicChunks, maxElementsInChunk), this.formatHumanReadableFilterChunk(rticChunks, maxElementsInChunk)];
    }

    formatHumanReadableFilterChunk(chunk, maxElementsInChunk) {
        if (chunk.length) {

            const formatter = new Intl.ListFormat("en-US", {
                style: 'long',
                type: 'disjunction',
            });

            chunk = [(chunk.length <= maxElementsInChunk) ? `in ${formatter.format(chunk)}` : `in ${chunk.length} RTIC sectors`];
        }
        return chunk;
    }

    newRtic(code, title, count, locked, cic) {
        let rtic = new RticFilter(code, title, count, locked, cic, this.elementIdPrefix, this);
        this.filters.push(rtic);
        return rtic;
    }

    addRticFiltersToPage() {
        this.filters.sort((a, b) => a.title.localeCompare(b.title)).forEach(filter => filter.addRticFilterContent());
    }

    updateRticFilterSummary() {
        let activeFilterCount = 0;
        let activeCicFilterCount = 0;
        this.filters.filter(filter => filter.cic === false).forEach(filter => activeFilterCount += filter.getTotalActiveFilters());
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControl[filtergroup="RTICs"] .total`).innerHTML = activeFilterCount;
        this.filters.filter(filter => filter.cic === true).forEach(filter => activeCicFilterCount += filter.getTotalActiveFilters());
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControl[filtergroup='CICs'] .total`).innerHTML = activeCicFilterCount;
        this.removePresetStyleFromCicFilterControl().removePresetStyleFromRticFilterControl();

        this.parent.checkForFiltersUpdate();
        return this;
    }

    resetRticFilters() {
        document.getElementById(this.elementIdPrefix + "RTICs-batch-control").checked = false;
        document.getElementById(this.elementIdPrefix + "CICs-batch-control").checked = false;
        this.filters.forEach(filter => filter.rticFilterBatchOff());
        this.updateRticFilterSummary();
        this.clearRticFilterSearch(document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControlHolder[filtergroup='RTICs'] .search-wrapper button[type='reset']`));
        return this;
    }

    allRticsFiltersBatchToggle(element) {
        let processCics = ((element.dataset.process_cics) == "true" ? true : false);
        if (element.checked) {
            this.allRticsFiltersBatchOn(processCics);
        } else {
            this.allRticsFiltersBatchOff(processCics);
        }
        this.updateRticFilterSummary();
        return this;
    }

    allRticsFiltersBatchOn(processCics) {
        this.filters.forEach(filter => filter.rticFilterBatchOn(processCics));
    }

    allRticsFiltersBatchOff(processCics) {
        this.filters.forEach(filter => filter.rticFilterBatchOff(processCics));
    }

    getActiveRticFilters() {
        let activeRticVerticalCodes = this.filters.filter(filter => filter.rticFilterIsActive()).map(filter => filter.getActiveRticVerticalCodes()).flat();
        if (activeRticVerticalCodes.length > 0) {
            return {SelectedRTICs: activeRticVerticalCodes};
        } else {
            return false;
        }
    }

    rticsFilterIsActive() {
        return this.filters.find(element => !element.cic && element.rticFilterIsActive()) != undefined;
    }

    getUserCics() {
        let activeCicSectors = this.filters.filter(filter => filter.cic === true).map(filter => filter.code);
        if (activeCicSectors.length > 0) {
            return {UserCICs: activeCicSectors}
        } else {
            return false;
        }
    }

    // Search rtic filters
    rticFilterSearch(filterString) {
        this.filters.forEach(rtic => { if (rtic.cic === false) { rtic.filterSearch(filterString) } });
    }

    clearRticFilterSearch(element) {
        let filterSearchInput = element.closest("form").querySelector("input");
        filterSearchInput.value = null;
        this.rticFilterSearch(filterSearchInput.value);
    }

    calculateActiveRtics() {
        let activeRtics, totalRtics, activeSubgroups;
        activeRtics = [];
        totalRtics = this.filters.length;
        for (var i = 0; i < totalRtics; i++) {
            activeSubgroups = this.filters[i].subgroups.filter(subgroup => subgroup.checked);
            activeSubgroups.forEach(activeSubgroup => activeRtics.push({
                group: activeSubgroup.rtic,
                subgroup: activeSubgroup.title
            }))
        }
        return activeRtics;
    }

    preloadRticSector(presetRtic, rticVertical) {
        let rticSector = decodeURIComponent(presetRtic);
        this.processStoredRticFilters(this.formatPresetRtic(rticSector, rticVertical));
        return this;
    }

    formatPresetRtic(presetRtic, presetRticVertical) {
        let presetRticObject, rticGroup, rticVerticals, presetRticFilters;
        if (presetRticObject = this.filters.find(filter => filter.title == presetRtic)) {
            rticGroup = presetRticObject.title;
            if (presetRticVertical) {
                rticVerticals = presetRticObject.verticals.filter(vertical => vertical.title == presetRticVertical);
            } else {
                rticVerticals = presetRticObject.verticals;
            }
            presetRticFilters = rticVerticals.map(vertical => vertical.code);
        }
        return presetRticFilters;
    }

    processStoredRticFiltersLegacy(storedRticFilters) {
        let storedRticVerticals, rticFilterElement;
        storedRticVerticals = [];
        storedRticFilters.forEach(storedRticFilter => {
            // Check whether a filter exists in the UI for the selected RTIC
            if (rticFilterElement = document.querySelector(`#${this.elementIdPrefix}filterControlsHolder input[data-sectorname='${storedRticFilter.group}'][data-vertical='${storedRticFilter.subgroup}']`)) {
                storedRticVerticals.push(rticFilterElement.name);
            }
        });
        this.processStoredRticFilters(storedRticVerticals);
    }

    processStoredRticFilters(storedRticFilters) {
        let rticGroup, rticSubgroup, storedRticFiltersTotal, rticFilterInput, rticPrimaryFilterToggle, storedRticFilterIsCic, rticIsActive, cicIsActive;
        storedRticFiltersTotal = storedRticFilters.length;
        for (var i = 0; i < storedRticFiltersTotal; i++) {
            rticSubgroup = storedRticFilters[i];
            if (rticFilterInput = document.querySelector(`#${this.elementIdPrefix}filterControlsHolder input[code='${rticSubgroup}']`))  {
                rticGroup = rticFilterInput.dataset.sectorname;
                storedRticFilterIsCic = this.storedRticFilterIsCic(rticGroup);
                rticFilterInput.click();
                rticPrimaryFilterToggle = document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterPrimary[rtic='${rticGroup}'] .filterSubgroupToggle input`);
                if (!rticPrimaryFilterToggle.checked) {
                    rticPrimaryFilterToggle.click();
                }
                if (!document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterSubgroupHolder[filtersubgroup='${rticGroup}'] input:not(:checked)`)) {
                    document.getElementById(`${this.elementIdPrefix}${rticGroup}-batch-control`).checked = true;
                }
                // Will turn CIC filters on
                if (storedRticFilterIsCic === true) {
                    cicIsActive = true;
                } else {
                    rticIsActive = true;
                }
            }
        }
        if (cicIsActive === true) {
            this.addPresetStyleToCicFilterControl();
        }
        if (rticIsActive === true) {
            this.addPresetStyleToRticFilterControl();
        }
    }

    addPresetStyleToRticFilterControl() {
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .controlHolder[filtergroup='RTICs']`).classList.add("filterPreset");
        return this;
    }

    removePresetStyleFromRticFilterControl() {
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .controlHolder[filtergroup='RTICs']`).classList.remove("filterPreset");
        return this;
    }

    addPresetStyleToCicFilterControl() {
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .controlHolder[filtergroup='CICs']`).classList.add("filterPreset");
        return this;
    }

    removePresetStyleFromCicFilterControl() {
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .controlHolder[filtergroup='CICs']`).classList.remove("filterPreset");
        return this;
    }

    storedRticFilterIsCic(rticGroup) {
        return this.filters.find(filter => (filter.title == rticGroup && filter.cic === true)) != undefined;
    }

    displayCicFilters(element) {
        if (!element.classList.contains("filterActive")) {
            document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterSubheading[filter='CICs']`).classList.add("filterActive");
            document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControlTable[filter='CICs']`).classList.add("filterControlTableActive");
            this.updateRticFilterSummary();
        }
        return this;
    }

    hideCicFilters() {
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterSubheading[filter='CICs']`).classList.remove("filterActive");
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControlTable[filter='CICs']`).classList.remove("filterControlTableActive");
    }
}

class RticCompanyVertical {
    constructor(sectorCode, sectorName, verticalCode, verticalName) {
        this.sectorCode = sectorCode;
        this.sectorName = sectorName;
        this.verticalCode = verticalCode;
        this.verticalName = verticalName;
    }
}

class RticFilter {
    constructor(code, title, count, locked, cic, elementIdPrefix, parent) {
        this.code = code;
        this.title = title;
        this.count = count;
        this.locked = locked;
        this.verticals = [];
        this.cic = cic;
        this.elementIdPrefix = elementIdPrefix;
        this.parent = parent;
    }

    rticFilterIsActive() {
        return this.verticals.filter(vertical => vertical.checked === true).length > 0;
    }

    getHumanReadableFilterChunk(maxElementsInChunk) {
        let content;
        const typeString = this.cic ? "CIC" : "RTIC";
        const formatter = new Intl.ListFormat("en-US", {
            style: 'long',
            type: 'disjunction',
        });
        // At least one vertical is not on, need long form of filter description
        if (this.verticals.find(element => !element.rticFilterVerticalActive())) {
            const activeVerticalNames = this.getActiveRticVerticalNames();
            content = `${(activeVerticalNames.length <= maxElementsInChunk) ? `the ${formatter.format(activeVerticalNames)}` : activeVerticalNames.length.toLocaleString()} ${coreFunctions.pluraliseWord("vertical", "verticals", activeVerticalNames.length)} of the ${this.title} ${typeString} sector`;
        } else {
            content = `the ${this.title} ${typeString} sector`;
        }
        return content;
    }

    getActiveRticVerticalNames() {
        return this.verticals.flatMap(element => element.checked ? [element.title] : []);
    }

    getActiveRticVerticalCodes() {
        return this.verticals.filter(vertical => vertical.checked === true).map(vertical => vertical.code);
    }

    processRticVerticals(rticVerticals, sectorIsCic) {
        const rticFilterObject = this;
        rticVerticals.sort((a, b) => a.name.localeCompare(b.name)).forEach(vertical => {
            let newVertical = new RticFilterVertical(vertical.code, vertical.name, vertical.memberscount, rticFilterObject.code, rticFilterObject.title, rticFilterObject.cic, rticFilterObject.elementIdPrefix, rticFilterObject);
            rticFilterObject.verticals.push(newVertical);
        });
        return this;
    }

    addCompanyCount(count) {
        this.count = count;
    }

    addCompaniesToVerticals(rticVerticalCompanies) {
        let rticVertical;
        for (var rticVerticalCode in rticVerticalCompanies) {
            if (rticVertical = this.verticals.find(vertical => vertical.code == rticVerticalCode)) {
                rticVertical.addCompaniesToVertical(rticVerticalCompanies[rticVerticalCode]);
            }
        }
    }
    // Add filters for this rtic
    addRticFilterContent() {
        const rticFilterObject = this;
        let rticFilterHolder, rticTitle, rticFilterSubgroupHolder, rticFilterSubgroup, rticMainControlHolder, filterSubgroupToggle;
        rticFilterHolder = document.createDocumentFragment();
        rticTitle = this.title;

        rticMainControlHolder = rticFilterHolder.appendChild(coreFunctions.createElementHelper("li", { class: "filterPrimary", rtic: rticTitle })); // Main holder

        rticMainControlHolder.appendChild(coreFunctions.createElementHelper("input", { filter: "RTICs", filtergroup: "RTICs", filtersubgroup: rticTitle, type: "checkbox", id: `${this.elementIdPrefix}${rticTitle}-batch-control`, "data-process_cics": `${this.cic}` }, { click: function (e) { rticFilterObject.rticFilterBatchToggle(this) } })); // Batch filter control

        rticMainControlHolder.appendChild(coreFunctions.createElementHelper("label", { for: `${this.elementIdPrefix}${rticTitle}-batch-control`, innerHTML: `${(this.cic === false) ? `<img class="rticLogo" src="${urlPath}/images/datacity_logo_icon.svg" loading='lazy'>` : ""}${rticTitle}<span class="filterTotal"> (${this.count.toLocaleString()})` }));

        filterSubgroupToggle = rticMainControlHolder.appendChild(coreFunctions.createElementHelper("span", { class: "filterSubgroupToggle" })); // Toggle RTIC subgroup filters holder

        filterSubgroupToggle.appendChild(coreFunctions.createElementHelper("input", { type: "checkbox", id: `${this.elementIdPrefix}${rticTitle}-subgroup-control`, class: "filterSubgroupInput", filtersubgroup: rticTitle }, { change: function (event) { rticFilterObject.onFilterSubgroupControlToggle(this) } })); // Control toggle

        filterSubgroupToggle.appendChild(coreFunctions.createElementHelper("label", { for: `${this.elementIdPrefix}${rticTitle}-subgroup-control` })); // Label element

        rticFilterSubgroupHolder = coreFunctions.createElementHelper("li", { class: "filterSubgroupHolder", "filtersubgroup": rticTitle }); // Holder for RTIC subsectors holder
        rticFilterHolder.appendChild(rticFilterSubgroupHolder);

        rticFilterSubgroup = coreFunctions.createElementHelper("ul", { class: "filterSubgroup" });
        rticFilterSubgroupHolder.appendChild(rticFilterSubgroup);
        this.verticals.forEach(subgroup => rticFilterSubgroup.appendChild(subgroup.addFilterForSubgroup())); // Add each RTIC subgroup

        // TODO
        if (this.cic === true) {
            document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControlUl[filter='CICs']`).appendChild(rticFilterHolder);
        } else {
            document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControlUl[filter='RTICs']`).appendChild(rticFilterHolder);
        }

    }

    // Toggle displaying of RTIC subgroups
    onFilterSubgroupControlToggle(element) {
        let filterSubgroup = element.getAttribute("filtersubgroup");
        let subgroupElement = element.closest(".filterControlUl").querySelector(".filterSubgroupHolder[filtersubgroup='" + filterSubgroup + "']");
        if (element.checked) {
            subgroupElement.classList.add("filterSubgroupVisible");
        } else {
            subgroupElement.classList.remove("filterSubgroupVisible");
        }
    }

    rticFilterBatchToggle(element) {
        let processCics = ((element.dataset.process_cics == "true") ? true : false);
        if (element.checked) {
            this.rticFilterBatchOn(processCics);
        } else {
            this.rticFilterBatchOff(processCics);
        }
        this.parent.updateRticFilterSummary();
        return this;
    }

    rticFilterBatchOn(processCics) {
        if (this.cic == processCics) {
            // Ensure batch control is updated
            document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterPrimary input[filtersubgroup="${this.title}"]`).checked = true;
            this.verticals.forEach(subgroup => subgroup.rticFilterSubgroupOn());
        }
    }

    rticFilterBatchOff(processCics) {
        if (processCics == undefined || this.cic == processCics) {
            // Ensure batch control is updated
            document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterPrimary input[filtersubgroup="${this.title}"]`).checked = false;
            this.verticals.forEach(subgroup => subgroup.rticFilterSubgroupOff());
        }
    }

    getTotalActiveFilters() {
        return this.verticals.filter(subgroup => subgroup.checked).length;
    }

    getActiveRticCompanies() {
        return this.verticals.filter(subgroup => subgroup.checked).map(subgroup => subgroup.companies).flat();
    }

    filterSearch(filterString) {
        let filterSubgroupsPassingSearch = this.verticals.filter(subgroup => subgroup.subgroupPassesSearch(filterString));
        if (filterSubgroupsPassingSearch.length > 0) {
            this.displayRticFilterControl();
        } else {
            this.hideRticFilterControl();
        }
    }

    displayRticFilterControl() {
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder li.filterPrimary[rtic='${this.title}']`).classList.remove("hidden");
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder li.filterSubgroupHolder[filtersubgroup='${this.title}']`).classList.remove("hidden");
    }

    hideRticFilterControl() {
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder li.filterPrimary[rtic='${this.title}']`).classList.add("hidden");
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder li.filterSubgroupHolder[filtersubgroup='${this.title}']`).classList.add("hidden");
    }

}

class RticFilterVertical {
    constructor(code, title, count, sectorCode, sectorName, cic, elementIdPrefix, parent) {
        this.code = code;
        this.title = title;
        this.sectorName = sectorName;
        this.sectorCode = sectorCode;
        this.count = count;
        this.checked = false;
        this.cic = cic;
        this.elementIdPrefix = elementIdPrefix;
        this.parent = parent;
    }

    rticFilterVerticalActive() {
        return this.checked;
    }

    subgroupPassesSearch(filterString) {
        if (this.title.toLowerCase().includes(filterString) || this.sectorName.toLowerCase().includes(filterString)) {
            this.displayFilterControl();
            return true;
        } else {
            this.hideFilterControl();
            return false;
        }
    }

    displayFilterControl() {
        document.getElementById(`${this.elementIdPrefix}checkbox-${(this.cic === true) ? 'CICs' : 'RTICs'}-${this.code}`).parentNode.classList.remove("hidden");
    }

    hideFilterControl() {
        document.getElementById(`${this.elementIdPrefix}checkbox-${(this.cic === true) ? 'CICs' : 'RTICs'}-${this.code}`).parentNode.classList.add("hidden");
    }

    addFilterForSubgroup() {
        const rticFilterSubgroup = this;
        let subsectorTitle, subgroupFilter;
        subsectorTitle = this.title;
        subgroupFilter = coreFunctions.createElementHelper("li")
        subgroupFilter.appendChild(coreFunctions.createElementHelper("input", { type: "checkbox", id: `${this.elementIdPrefix}checkbox-${(this.cic === true) ? 'CICs' : 'RTICs'}-${this.code}`, group: subsectorTitle, code: this.code, name: this.code, filter: "RTICs", "data-vertical": subsectorTitle, "data-sectorname": this.sectorName, "data-sectorcode": this.sectorCode }, { change: function (e) { rticFilterSubgroup.rticFilterToggle(this) } }));
        subgroupFilter.appendChild(coreFunctions.createElementHelper("label", { for: `${this.elementIdPrefix}checkbox-${(this.cic === true) ? 'CICs' : 'RTICs'}-${this.code}`, innerHTML: `${this.sectorName}: ${subsectorTitle}<span class="filterTotal"> (${this.count.toLocaleString()})</span>` }));
        return subgroupFilter;
    }

    rticFilterToggle(element) {
        this.checked = element.checked;
        this.parent.parent.updateRticFilterSummary();
    }

    rticFilterSubgroupOn() {
        this.checked = true;
        document.getElementById(`${this.elementIdPrefix}checkbox-${(this.cic === true) ? 'CICs' : 'RTICs'}-${this.code}`).checked = true;
    }

    rticFilterSubgroupOff() {
        this.checked = false;
        document.getElementById(`${this.elementIdPrefix}checkbox-${(this.cic === true) ? 'CICs' : 'RTICs'}-${this.code}`).checked = false;
    }
}

class CompaniesFilter {
    constructor(elementIdPrefix, parent) {
        this.companyName = null;
        this.companyNumbers = [];
        this.activeField = null;
        this.companyFilterResetLocked = false;
        this.manuallyIncludedCompanies = [];
        this.manuallyExcludedCompanies = [];
        this.exploreManuallyIncludedCompanies = [];
        this.exploreManuallyExcludedCompanies = [];
        this.elementIdPrefix = elementIdPrefix;
        this.parent = parent;
    }

    companyNumbersChange(value) {
        const companiesFilterObject = this;
        // Reset existing saved values
        companiesFilterObject.companyNumbers = [];
        let textAreaInputSplit = value.trim().split(/,\s*|\s{1,}|\n/);
        textAreaInputSplit.forEach((companyNumber) => {
            if (companyNumber.length < 8) {
                while (companyNumber.length != 8) {
                    companyNumber = "0" + companyNumber;
                }
            }
            companiesFilterObject.companyNumbers.push(companyNumber);
        });
        this.activeField = "CompanyNumbers";
        return this;
    }

    exploreIncludeCompanyNumbersChange(value) {
        const companiesFilterObject = this;
        // Reset existing saved values
        companiesFilterObject.exploreManuallyIncludedCompanies = [];
        let textAreaInputSplit = value.trim().split(/,\s*|\s{1,}|\n/);
        textAreaInputSplit.forEach((companyNumber) => {
            if (companyNumber.length < 8) {
                while (companyNumber.length != 8) {
                    companyNumber = "0" + companyNumber;
                }
            }
            companiesFilterObject.exploreManuallyIncludedCompanies.push(companyNumber);
        });
        return this;
    }

    exploreExcludeCompanyNumbersChange(value) {
        const companiesFilterObject = this;
        // Reset existing saved values
        companiesFilterObject.exploreManuallyExcludedCompanies = [];
        let textAreaInputSplit = value.trim().split(/,\s*|\s{1,}|\n/);
        textAreaInputSplit.forEach((companyNumber) => {
            if (companyNumber.length < 8) {
                while (companyNumber.length != 8) {
                    companyNumber = "0" + companyNumber;
                }
            }
            companiesFilterObject.exploreManuallyExcludedCompanies.push(companyNumber);
        });
        return this;
    }

    addStoredCompanyName(companyName) {
        this.companyName = null;
        if (companyName && document.getElementById("companyNumberNameUrlInput")) {
            document.getElementById("companyNumberNameUrlInput").value = companyName;
        }
    }

    addStoredCompanyNumbers(companyNumbers) {
        this.companyNumbers = [];
        let companyNumbersContent = this.prepopulateCompanyNumbersContent(companyNumbers);
        document.getElementById(this.elementIdPrefix + "searchCompanyNumbers").value = companyNumbersContent;
        this.companyNumbersChange(companyNumbersContent).companyNumbersFilterActive().addPresetStyleToFilterControl();
    }

    addStoredExploreIncludedCompanyNumbers(companyNumbers) {
        this.exploreManuallyIncludedCompanies = [];
        let companyNumbersContent = this.prepopulateCompanyNumbersContent(companyNumbers);
        document.getElementById(this.elementIdPrefix + "includeCompanyNumbers").value = companyNumbersContent;
        this.exploreIncludeCompanyNumbersChange(companyNumbersContent).companyNumbersIncludeExcludeActive().addPresetStyleToFilterControl();
    }

    addStoredExploreExcludedCompanyNumbers(companyNumbers) {
        this.exploreManuallyExcludedCompanies = [];
        let companyNumbersContent = this.prepopulateCompanyNumbersContent(companyNumbers);
        document.getElementById(this.elementIdPrefix + "excludeCompanyNumbers").value = companyNumbersContent;
        this.exploreExcludeCompanyNumbersChange(companyNumbersContent).companyNumbersIncludeExcludeActive().addPresetStyleToFilterControl();
    }

    addPresetStyleToFilterControl() {
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .controlHolder[filtergroup='companies']`).classList.add("filterPreset");
        return this;
    }

    removePresetStyleFromFilterControl() {
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .controlHolder[filtergroup='companies']`).classList.remove("filterPreset");
        return this;
    }

    prepopulateCompanyNumbersContent(companyNumbers) {
        let textAreaContent = '';
        companyNumbers.forEach(function (companyNumber) {
            textAreaContent += companyNumber + "\n"
        })
        return textAreaContent;
    }

    companyNameChange(value) {
        if (value.length > 0) {
            this.companyName = value;
            this.activeField = "CompanyName";
        } else {
            this.companyName = null;
        }
        return this;
    }

    companyNameFilterIsActive() {
        return (document.getElementById("companyNumberNameUrlInput") && document.getElementById("companyNumberNameUrlInput").value && document.getElementById("companyNumberNameUrlInput").value.length > 0);
    }

    updateCompaniesFilterTotal() {
        let totalElement = document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControl[filtergroup='companies'] .total`);
        if (this.activeField == "CompanyNumbers" && this.companyNumbers && this.companyNumbers.length > 0) {
            totalElement.innerHTML = this.companyNumbers.length;
        } else if (this.activeField == "CompanyNumbersIncludeExclude") {
            totalElement.innerHTML = this.exploreManuallyIncludedCompanies.length + this.exploreManuallyExcludedCompanies.length;
        } else {
            totalElement.innerHTML = 0;
        }
        this.removePresetStyleFromFilterControl()
        this.parent.checkForFiltersUpdate();
        return this;
    }


    filterSubgroupToggleClick(element) {
        if (!element.classList.contains("filterActive")) {
            if (element.getAttribute("filter") == "companyNumbersIncludeExclude") {
                this.companyNumbersIncludeExcludeActive();
            } else {
                this.companyNumbersFilterActive();
            }
        }
        return this;
    }

    companyNameFilterActive() {
        this.hideFilter("companyNumbers");
        this.showFilter("companyName");
        this.activeField = "CompanyName";
        this.updateCompaniesFilterTotal();
        return this;
    }

    companyNumbersIncludeExcludeActive() {
        this.hideFilter("companyNumbers");
        this.showFilter("companyNumbersIncludeExclude");
        this.activeField = "CompanyNumbersIncludeExclude";
        this.updateCompaniesFilterTotal();
        return this;
    }

    companyNumbersFilterActive() {
        this.hideFilter("companyNumbersIncludeExclude");
        this.showFilter("companyNumbers");
        this.activeField = "CompanyNumbers";
        this.updateCompaniesFilterTotal();
        return this;
    }

    hideFilter(filter) {
        let activeFilter;
        if (activeFilter = document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterSubheading.filterActive[filter='${filter}']`)) {
            activeFilter.classList.remove("filterActive");
            document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControlTable.filterControlTableActive[filter='${filter}'][filtergroup='companies']`).classList.remove("filterControlTableActive");
        }
        return this;
    }

    showFilter(filter) {
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterSubheading[filter='${filter}']`).classList.add("filterActive");
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControlTable[filter='${filter}']`).classList.add("filterControlTableActive");
        return this;
    }

    resetCompaniesFilter() {
        if (this.companyFilterResetLocked === false) {
            this.companyName = null;
            this.companyNumbers = [];
            this.exploreManuallyIncludedCompanies = [];
            this.exploreManuallyExcludedCompanies = [];
            document.getElementById(this.elementIdPrefix + "searchCompanyNumbers").value = null;
            this.clearCompanyNameNumberUrlSearchElement();
            this.clearExploreManualIncludeExcludeElements();
            this.updateCompaniesFilterTotal();
        }
        return this;
    }

    getActiveCompanyNameNumberUrlFilter() {
        let companyNameFilter = {};
        if (document.getElementById("companyNumberNameUrlInput") && document.getElementById("companyNumberNameUrlInput").value) {
            document.getElementById("companyNumberNameUrlInput").value = document.getElementById("companyNumberNameUrlInput").value.trim();
            companyNameFilter["CompanyName"] = document.getElementById("companyNumberNameUrlInput").value;
        }
        return companyNameFilter;
    }

    clearCompanyNameNumberUrlSearchElement() {
        if (document.getElementById("companyNumberNameUrlInput")) {
            document.getElementById("companyNumberNameUrlInput").value = null;
        }
        return this;
    }

    getActiveCompanyFilters() {
        let companyFilters = {};
        Object.assign(companyFilters, this.getActiveCompanyNameNumberUrlFilter());
        if (this.activeField == "CompanyNumbers" && this.companyNumbers.length > 0) {
            Object.assign(companyFilters, { "CompanyNumbers": this.companyNumbers });
        } else if (
                this.activeField == "CompanyNumbersIncludeExclude" &&
                (this.exploreManuallyIncludedCompanies.length > 0 || this.exploreManuallyExcludedCompanies.length > 0)
        ) {
            Object.assign(companyFilters, { "ExploreManuallyInclude": this.exploreManuallyIncludedCompanies ?? [], "ExploreManuallyExclude": this.exploreManuallyExcludedCompanies ?? [] });
        }
        return companyFilters;
    }

    toggleCompaniesFilterLock(element) {
        this.companyFilterResetLocked = element.checked;
        if (this.companyFilterResetLocked === true) {
            this.companiesFilterLockOn();
        } else {
            this.companiesFilterLockOff();
        }
    }

    companiesFilterLockOff() {
        this.companyFilterResetLocked = false;
        document.getElementById(this.elementIdPrefix + "companiesFilterLock").checked = false;
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControl[filtergroup='companies']`).classList.remove("companiesFilterResetLocked");
    }

    companiesFilterLockOn() {
        this.companyFilterResetLocked = true;
        document.getElementById(this.elementIdPrefix + "companiesFilterLock").checked = true;
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControl[filtergroup='companies']`).classList.add("companiesFilterResetLocked");
    }

    manuallyIncludeCompany(companyNumber) {
        this.manuallyIncludedCompanies.push(companyNumber);
    }

    manuallyExcludeCompany(companyNumber) {
        this.manuallyExcludedCompanies.push(companyNumber);
    }

    setManuallyIncludedCompanyNumbers(companyNumbers) {
        this.manuallyIncludedCompanies = companyNumbers;
    }

    setManuallyExcludedCompanyNumbers(companyNumbers) {
        this.manuallyExcludedCompanies = companyNumbers;
    }

    removeManuallyIncludedCompany(companyNumber) {
        this.manuallyIncludedCompanies.splice(this.manuallyIncludedCompanies.indexOf(companyNumber), 1);
    }

    removeManuallyExcludedCompany(companyNumber) {
        this.manuallyExcludedCompanies.splice(this.manuallyExcludedCompanies.indexOf(companyNumber), 1);
    }

    getManuallyIncludedAndExcludedCompanies() {
        const manuallyIncludedAndExcludedCompanies = {};
        if (this.manuallyIncludedCompanies.length > 0) {
            manuallyIncludedAndExcludedCompanies.ManuallyInclude = this.manuallyIncludedCompanies;
        }
        if (this.manuallyExcludedCompanies.length > 0) {
            manuallyIncludedAndExcludedCompanies.ManuallyExclude = this.manuallyExcludedCompanies;
        }
        return manuallyIncludedAndExcludedCompanies;
    }

    clearExploreManualIncludeExcludeElements() {
        if (document.getElementById("includeCompanyNumbers")) {
            document.getElementById("includeCompanyNumbers").value = null;
        }
        if (document.getElementById("excludeCompanyNumbers")) {
            document.getElementById("excludeCompanyNumbers").value = null;
        }
        return this;
    }

    companyNameNumberUrlOnChange(element) {
        const searchIsActive = element.value && element.value.length > 0;
        this.updateSearchMatchSortByField(searchIsActive);
    }

    updateSearchMatchSortByField(searchIsActive) {
        let sortByOption;
        if (sortByOption = document.querySelector("#sortByField [value='ascSearchMatch']")) {
            sortByOption.disabled = !searchIsActive;
        }
    }

}

class KeywordFilters {
    constructor(containsOperator, doesNotContainOperator, elementIdPrefix, page, parent) {
        this.containsOperator = containsOperator;
        this.containsKeywords = [];
        this.doesNotContainOperator = doesNotContainOperator;
        this.doesNotContainKeywords = [];
        this.elementIdPrefix = elementIdPrefix;
        this.page = page;
        this.parent = parent;
    }

    addNewKeyword(formElement) {
        let inputElement, newKeyword;
        inputElement = formElement.querySelector("input");
        if (inputElement.value.length > 0) {
            newKeyword = new KeywordFilterElement(this.removeSingleApostrophesFromKeyword(inputElement.value.trim()), inputElement.getAttribute("keywordtype"), this.elementIdPrefix, this).newKeywordElement();
            if (newKeyword.type == "include") {
                this.containsKeywords.push(newKeyword);
            } else {
                this.doesNotContainKeywords.push(newKeyword);
            }
            inputElement.value = null;
            this.updateKeywordsTotal().checkStateForKeywordSorting();
        }
        return this;
    }

    getHumanReadableFilterChunk() {
        let chunk = [];
        if (this.keywordFilteringActive()) {
            let content = "with webtext that ";
            const containsKeywordsActive = this.keywordsActive(this.containsKeywords);
            const doesNotContainKeywordsActive = this.keywordsActive(this.doesNotContainKeywords);
            if (containsKeywordsActive) {
                const containsKeywordsFormatter = new Intl.ListFormat('en', {
                    style: 'long',
                    type:  this.containsOperator == 'AND' ? 'conjunction' : 'disjunction',
                });
                const containsKeywords = this.containsKeywords.map(element => element.keyword);
                content += `contains the ${coreFunctions.pluraliseWord("term", "terms", containsKeywords.length)} ${containsKeywordsFormatter.format(containsKeywords)}`;
            }
            if (doesNotContainKeywordsActive) {
                const doesNotContainKeywordsFormatter = new Intl.ListFormat('en', {
                    style: 'long',
                    type:  this.doesNotContainOperator == 'AND' ? 'conjunction' : 'disjunction',
                });
                content += containsKeywordsActive ? ", and " : "";
                const doesNotContainKeywords = this.doesNotContainKeywords.map(element => element.keyword);
                content += `does not contain the ${coreFunctions.pluraliseWord("term", "terms", doesNotContainKeywords.length)} ${doesNotContainKeywordsFormatter.format(doesNotContainKeywords)}`;
            }
            chunk = [content];
        }

        return chunk;
    }

    removeSingleApostrophesFromKeyword(keyword) {
        return keyword.replace(/'/g, '"');
    }

    removeKeyword(keyword, type) {
        if (type == "include") {
            this.containsKeywords.splice(this.containsKeywords.findIndex(element => element.keyword == keyword), 1);
        } else {
            this.doesNotContainKeywords.splice(this.doesNotContainKeywords.findIndex(element => element.keyword == keyword), 1);
        }
        this.updateKeywordsTotal().checkStateForKeywordSorting();
        if (this.page == "mlListPage") {
            mlListPage.mlList.myWords.keywordRemoved(keyword);
        }
        return this;
    }

    addKeywordFormMlListMyWord(keyword, keywordType) {
        let newKeyword = new Keyword(keyword, keywordType, this.elementIdPrefix, this).newKeywordElement();
        if (keywordType == "include") {
            this.containsKeywords.push(newKeyword);
        } else {
            this.doesNotContainKeywords.push(newKeyword);
        }
        this.updateKeywordsTotal().checkStateForKeywordSorting();
    }

    updateKeywordsTotal() {
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .keywordControl .total`).innerHTML = this.containsKeywords.length + this.doesNotContainKeywords.length;
        this.removePresetStyleFromFilterControl();
        this.parent.checkForFiltersUpdate();
        return this;
    }

    resetAllKeywords() {
        // Make copies of arrays to loop through
        this.containsKeywords.slice(0).forEach(keyword => keyword.deleteKeywordElement());
        this.doesNotContainKeywords.slice(0).forEach(keyword => keyword.deleteKeywordElement());
        Array.from(document.querySelectorAll(".keywordFilter input")).forEach(input => input.value = null);
        this.updateKeywordsTotal().checkStateForKeywordSorting();
        return this;
    }

    // If sorting available change state of keywords options
    checkStateForKeywordSorting() {
        if (document.querySelector("#sortByField")) {
            if (this.keywordFilteringActive()) {
                document.querySelector("#sortByField option[name='Keywords']").disabled = false;
            } else {
                document.querySelector("#sortByField option[name='Keywords']").disabled = true;
            }
        }
        return this;
    }

    updateIncludeOperator(value) {
        this.containsOperator = value;
        this.parent.checkForFiltersUpdate();
        return this;
    }

    updateExcludeOperator(value) {
        this.doesNotContainOperator = value;
        this.parent.checkForFiltersUpdate();
        return this;
    }

    getTotalKeywords() {
        return this.containsKeywords.length + this.doesNotContainKeywords.length;
    }

    keywordFilteringActive() {
        return (this.getTotalKeywords() > 0);
    }

    getArrayOfActiveKeywords() {
        return this.containsKeywords.map(element => element.keyword).concat(this.doesNotContainKeywords.map(element => element.keyword));
    }

    getActiveKeywordFiltersForSavedList() {
        if (this.getTotalKeywords() > 0) {
            return {
                keywords: {
                    include: {
                        operator: this.containsOperator,
                        keywords: this.containsKeywords.map(element => element.keyword)
                    },
                    exclude: {
                        operator: this.doesNotContainOperator,
                        keywords: this.doesNotContainKeywords.map(element => element.keyword)
                    }
                }
            }
        } else {
            return false;
        }
    }

    keywordsActive(keywordsArray) {
        return (keywordsArray.length > 0);
    }

    getActiveKeywordFilters() {
        const keywordFilters = {};
        if (this.getTotalKeywords() > 0) {
            if (this.keywordsActive(this.containsKeywords)) {
                keywordFilters["ContainsKeyword"] = this.containsKeywords.map(element => element.keyword).join(` ${this.containsOperator} `);
            }
            if (this.keywordsActive(this.doesNotContainKeywords)) {
                keywordFilters["DoesNotContainKeyword"] = this.doesNotContainKeywords.map(element => element.keyword).join(` ${this.doesNotContainOperator} `);
            }
            return keywordFilters;
        } else {
            return false;
        }
    }

    // Format stored keywords from last run search. Will be same format as keyword filters sent to API
    processStoredKeywordsObject(object) {
        const keywordsObject = {};
        if (object.include && object.include.keywords.length) {
            keywordsObject["ContainsKeyword"] = object.include.keywords.join(` ${object.include.operator} `);
        }
        if (object.exclude && object.exclude.keywords.length) {
            keywordsObject["DoesNotContainKeyword"] = object.exclude.keywords.join(` ${object.exclude.operator} `);
        }
        if (Object.keys(keywordsObject).length) {
            return keywordsObject;
        } else {
            return false;
        }


    }

    processStoredKeywords(storedKeywords) {
        const self = this;
        let includeOperator, excludeOperator;

        // Update operators
        includeOperator = storedKeywords.include.operator;
        document.getElementById(this.elementIdPrefix + "includeKeywordOperator").value = includeOperator;
        this.containsOperator = includeOperator;

        excludeOperator = storedKeywords.exclude.operator;
        document.getElementById(this.elementIdPrefix + "excludeKeywordOperator").value = excludeOperator;
        this.doesNotContainOperator = excludeOperator;

        // Add stored keywords to page
        storedKeywords.include.keywords.forEach((keyword) => {
            let includeKeyword = new Keyword(keyword, "include", self.elementIdPrefix, self).newKeywordElement();
            this.containsKeywords.push(includeKeyword);
        });
        storedKeywords.exclude.keywords.forEach((keyword) => {
            let excludeKeyword = new Keyword(keyword, "exclude", self.elementIdPrefix, self).newKeywordElement();
            this.doesNotContainKeywords.push(excludeKeyword);
        });

        return this;
    }

    addPresetStyleToFilterControl() {
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .controlHolder[filtergroup='keywords']`).classList.add("filterPreset");
        return this;
    }

    removePresetStyleFromFilterControl() {
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .controlHolder[filtergroup='keywords']`).classList.remove("filterPreset");
        return this;
    }

}

class KeywordFilterElement {
    constructor(keyword, type, elementIdPrefix, parent) {
        this.keyword = keyword;
        this.type = type;
        this.elementIdPrefix = elementIdPrefix;
        this.parent = parent;
    }

    newKeywordElement() {
        let holder, li, liButton, liSpan;
        const keyword = this;
        holder = document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .chosenKeywords[keywordtype='${this.type}']`);
        holder.classList.remove("hidden");

        li = coreFunctions.createElementHelper("li", { keyword: this.keyword, keywordtype: this.type });
        liButton = li.appendChild(coreFunctions.createElementHelper("button", { innerHTML: "&nbsp;", type: "button" }, { click: function (e) { keyword.deleteKeywordElement() } }));
        liSpan = li.appendChild(coreFunctions.createElementHelper("span", { innerHTML: this.keyword }));
        holder.appendChild(li);

        return this;
    }

    deleteKeywordElement() {
        let li, ul;
        li = document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .chosenKeywords[keywordtype='${this.type}'] li[keyword='${this.keyword}']`);
        ul = li.closest("ul");
        ul.removeChild(li);
        if (ul.children.length == 0) {
            ul.classList.add("hidden");
        }
        if (this.parent) {
            this.parent.removeKeyword(this.keyword, this.type);
        }

        return this;
    }
}

class GeneralFilters {
    constructor(elementIdPrefix, parent) {
        this.filters = [];
        this.elementIdPrefix = elementIdPrefix;
        this.parent = parent;
    }

    addAllFilters(response) {
        let allFilters = response.filters;
        if (allFilters.hasOwnProperty("SIC_counts")) {
            this.newGeneralFilter("SICs", "sectors", "SelectedSICs", "SICs", "SIC code(es)").createFilterElements(allFilters.SIC_counts).addFilterToPage();
        }
        if (allFilters.hasOwnProperty("RSIC_counts")) {
            this.newGeneralFilter("RSICs", "RSICs", "SelectedRSICs", "RSICs", "RSIC code(es)").createFilterElements(allFilters.RSIC_counts).addFilterToPage();
        } else {
            this.removeFilterControls("RSICs");
        }
		if (allFilters.hasOwnProperty("RSIC_counts")) {
            this.newGeneralFilter("RSICs", "RSICs", "SelectedRSICs", "RSICs", "RSIC code(es)").createFilterElements(allFilters.RSIC_counts).addFilterToPage();
        } else {
            this.removeFilterControls("RSICs");
        }
        if (allFilters.hasOwnProperty("SICHLU_counts")) {
            this.newGeneralFilter("SICHLUs", "sectors", "SelectedSICHLUs", "SICHLUs", "SIC section(ns)").createFilterElements(allFilters.SICHLU_counts).addFilterToPage();
        }
        if (allFilters.hasOwnProperty("Category_counts")) {
            this.newGeneralFilter("Categories", "sectors", "SelectedCategories", "CompanyCategory", "Company category(ies)").createFilterElements(allFilters.Category_counts).addFilterToPage();
        }
        if (allFilters.hasOwnProperty("City_counts")) {
            this.newGeneralFilter("Cities", "locations", "SelectedCities", "StandardisedCity", "city(ies)").createFilterElements(allFilters.City_counts).addFilterToPage();
        }
        if (allFilters.hasOwnProperty("LAName_counts")) {
            this.newGeneralFilter("LANames", "locations", "SelectedLACodes", "LAname", "local authority(ies)").createFilterElements(allFilters.LAName_counts).addFilterToPage();
        }
        // if (allFilters.hasOwnProperty("NUTS1Regions_counts")) {
        //     this.newGeneralFilter("NUTS1Regions", "locations", "SelectedNUTS1Regions", "NUTS1NM").createFilterElements(allFilters.NUTS1Regions_counts).addFilterToPage();
        // }
        if (allFilters.hasOwnProperty("Constituencies_counts")) {
            this.newGeneralFilter("Constituencies", "locations", "SelectedUKConstituencies", "UKConstituency", "constituency(ies)").createFilterElements(allFilters.Constituencies_counts).addFilterToPage();
        }
        if (allFilters.hasOwnProperty("LEPName_counts")) {
            this.newGeneralFilter("LEPNames", "locations", "SelectedLEPNames", null, "LEP(Ps)").createFilterElements(allFilters.LEPName_counts).addFilterToPage();
        }
        if (allFilters.hasOwnProperty("UltimateParentCompanyNation_counts")) {
            this.newGeneralFilter("UltimateParentCompanyNation", "locations", "SelectedUltimateParentNations", "UltimateParentCompanyNation", "parent nation(ns)").createFilterElements(allFilters.UltimateParentCompanyNation_counts.reverse()).addFilterToPage();
        }
        if (allFilters.hasOwnProperty("GrowthStages")) {
            this.newGeneralFilter("GrowthStages", "growth", "SelectedGrowthStages", null, "Growth Stage(es)").createFilterElements(this.sortGrowthStages(allFilters.GrowthStages)).addFilterToPage();
        }
        // if (allFilters.hasOwnProperty("ITL1_counts")) {
        //     this.newGeneralFilter("ITL1", "locations", "SelectedITL1Regions", null, "ITL1 region(ns)").createFilterElements(allFilters.ITL1_counts).addFilterToPage();
        // }
        // if (allFilters.hasOwnProperty("ITL2_counts")) {
        //     this.newGeneralFilter("ITL2", "locations", "SelectedITL2Regions", null, "ITL2 region(ns)").createFilterElements(allFilters.ITL2_counts).addFilterToPage();
        // }

        if (allFilters.hasOwnProperty("ITL_counts")) {
            this.newGeneralFilter("ITL_counts", "locations", "SelectedITL2Regions",  null, "ITL region(s)", true).createFilterElements(allFilters.ITL_counts, "ITL2_Counts").addFilterToPage();
        }

        // if (allFilters.hasOwnProperty("CountriesOfOrigin")) {
        //     this.newGeneralFilter("CountriesOfOrigin", "locations", "SelectedCountriesOfOrigin", "CountryOfOrigin").createFilterElements(allFilters.CountriesOfOrigin, allFilters.CountriesOfOrigin_counts).addFilterToPage();
        // }

        if (allFilters.hasOwnProperty("DealroomRoundTypes")) {
            this.newGeneralFilter("FundingRoundTypes", "funding_round", "DealroomRoundType", null, "Funding round(ds)", false, true).createFilterElements(allFilters.DealroomRoundTypes).addFilterToPage();
        }

        if (allFilters.hasOwnProperty("PostcodeOutcode_counts")) {
           this.newGeneralFilter("Postcodes", "locations", "SelectedPostcodeOutcodes",  null, "Postcode outcode(es)", true).createFilterElements(allFilters.PostcodeOutcode_counts, "Outcodes").addFilterToPage();
        }

        this.parent.checkForStoredFilters();

        return this;

    }

    removeFilterControls(filtergroup) {
        let filterControls;
        if (filterControls = document.querySelectorAll(`.filterControl[filtergroup='${filtergroup}']`)) {
            filterControls.forEach(element => element.remove());
        }
    } 

    getHumanReadableFilterChunks(maxElementsInChunk) {
        return this.filters.flatMap(element => {
            const chunk = element.getHumanReadableFilterChunk(maxElementsInChunk);
            return chunk ? [chunk] : [];
        });
    }

    newGeneralFilter(filter, filterGroup, queryField, legacyField, filterLabel, multiTierFilter = false, partialDataset = false) {
        let generalFilter;
        if (filter == "Postcodes") {
            generalFilter = new PostcodeGeneralFilter(filter, filterGroup, queryField, legacyField, this.elementIdPrefix, this, multiTierFilter, partialDataset, filterLabel);
        } else {
            generalFilter = new GeneralFilter(filter, filterGroup, queryField, legacyField, this.elementIdPrefix, this, multiTierFilter, partialDataset, filterLabel);
        }
        this.filters.push(generalFilter);
        return generalFilter;
    }

    filterSearch(filterGroup, searchString) {
        let activeFilter, batchControl;
        if (activeFilter = this.filters.find(filter => filter.filterGroup == filterGroup && filter.filterActive === true)) {
            if (batchControl = document.getElementById(`${this.elementIdPrefix}checkbox-${activeFilter.filter}-batch`)) {
                batchControl.checked = false;
            }
            activeFilter.elements.forEach(filterElement => filterElement.filterElementSearch(searchString));
        }
    }

    filterSearchReset(filterGroup) {
        this.filters.forEach((filter) => { if (filter.filterGroup == filterGroup && filter.filterActive === true) { filter.elements.forEach(filterElement => filterElement.displayFilterElement()) } });
    }

    getActiveGeneralFilters() {
        const activeGeneralFilters = {};
        this.filters.forEach(filter => Object.assign(activeGeneralFilters, filter.getActiveFilters()));
        return activeGeneralFilters;
    }

    getFilteredLocations() {
        let activeLocationFilter = analyse.filters.generalFilters.filters.find(element => element.filterGroup == "locations" && element.filterActive == true);
        return {
            field: activeLocationFilter.filter,
            locations: Object.values(activeLocationFilter.getActiveFilters()).flat(),
            names: activeLocationFilter.getActiveFilterNames()
        }
    }

    // getPostcodeSearchFilter() {
    //     if (document.getElementById("postcodeSearchInput") && document.getElementById("postcodeSearchInput").value && document.getElementById("postcodeSearchInput").value.length > 0) {
    //         return document.getElementById("postcodeSearchInput").value.toUpperCase();
    //     }
    //     return "";
    // }

    // setPostcodeSearchFilter(value) {
    //     if (document.getElementById("postcodeSearchInput")) {
    //         document.getElementById("postcodeSearchInput").value = value.toUpperCase();
    //     }
    // }

    // getPostcodeSearchRadiusFilter() {
    //     if (document.getElementById("postcodeSearchRadiusSelect") && document.getElementById("postcodeSearchRadiusSelect").value) {
    //         return parseInt(document.getElementById("postcodeSearchRadiusSelect").value);
    //     }
    //     return "";
    // }

    // setPostcodeSearchRadiusFilter(value) {
    //     if (document.getElementById("postcodeSearchRadiusSelect")) {
    //         document.getElementById("postcodeSearchRadiusSelect").value = parseInt(value);
    //     }
    // }

    resetGeneralFilters() {
        let totalFilters = this.filters.length;
        for (var i = 0; i < totalFilters; i++) {
            this.filters[i].resetFilter();
        }
    }

    resetGeneralFilterCheckboxes() {
        const checkboxes = ["registeredAddressOnly", "notKnownToBeForeign", "registeredAddressWithinFilteredLocationOnly", "calculateInsightsBasedOnlyOnRegisteredAddresses", "oecdScaleupCheckbox", "universitySpinoutCheckbox", "womenLedCompaniesCheckbox", "womenFoundedCompaniesCheckbox", "hasLightcastDataCheckbox", "anyActiveFounder"];
        checkboxes.forEach(checkbox => {let element; if (element = document.getElementById(checkbox)) {element.checked = false}});
        return this;
    }

    sortGrowthStages(growthStages) {
        const growthStagesOrdered = ["No employees or turnover", "Micro", "Small", "Medium", "Large"];
        growthStages.sort((a,b) => (growthStagesOrdered.indexOf(a.Thing) - growthStagesOrdered.indexOf(b.Thing)));
        return growthStages;
    }

    filterGroupIsActive(filterGroup) {
        // Filter will be active if at least one child item is unchecked, and one is checked. Ignore if all elements active or inactive
       return (this.filters.find(element => element.filterGroup == filterGroup && element.filterActive && element.elements.find(item => !item.checked) && element.elements.find(item => item.checked))) !== undefined;
    }

}

class GeneralFilter {

    constructor(filter, filterGroup, queryField, legacyField, elementIdPrefix, parent, multiTierFilter, partialDataset, filterLabel) {
        this.filter = filter;
        this.filterGroup = filterGroup;
        this.filterGroupParent = ""; // Filter is combined with several other types into a larger group.
        this.filterActive = (document.querySelector(`#${elementIdPrefix}filterControlsHolder .filterSubheading.filterActive[filter='${filter}']`) || filter == "GrowthStages" || filter == "FundingRoundTypes") ? true : false;
        this.elements = [];
        this.queryField = queryField;
        this.legacyField = legacyField;
        this.elementIdPrefix = elementIdPrefix;
        this.parent = parent;
        this.multiTierField = multiTierFilter;
        if (filterGroup == null) {
            this.filterActive = true;
        }
        this.partialDataset = partialDataset; // Filter field does not represent all companies in database
        this.filterLabel = filterLabel ?? null;
    }

    getHumanReadableFilterChunk(maxElementsInChunk) {
        let content = "";
        if (this.addFilterToQuery()) {
            const activeElements = this.multiTierField ? this.elements.flatMap(element => element.getActiveGeneralFilterTierElements()) : this.elements.flatMap(element => element.filterTurnedOn() ? [element.name ?? element.code] : []);
            const formatter = new Intl.ListFormat('en', {
                style: 'long',
                type: 'disjunction',
            });
            content += `in ${(activeElements.length <= maxElementsInChunk) ? `the ${formatter.format(activeElements)}` : activeElements.length.toLocaleString()} ${this.formatFilterLabel(activeElements.length)}`;
        }
        return content;
    }

    formatFilterLabel(count) {
        if (count == 1) {
            return this.filterLabel.replace(/\([^()]*\)/g, ""); // Remove brackets and contents within (for internal contents ignore brackets). Leaves singular form
        } else {
            return this.filterLabel.replace(/(.\(|\))/g, ""); // Remove brackets and character before to leave the plural form
        }
    }

    createFilterElements(filterCounts, multiTierField = false) {
        filterCounts.forEach(filter => {
            if (multiTierField) {
                this.processMultiTierFieldElement(filter, multiTierField);
            } else {
                const filterElementId = filter.ID ?? filter.Thing;
                const filterElementName = filter.Name ?? null;
                if (this.isFilterValid(filterElementId)) {
                    this.newFilterElement(filterElementId, filter.Count, filterElementName);
                }
            }
        });
        return this;
    }

    processMultiTierFieldElement(filterElement, multiTierField) {
        if (filterElement.Thing || filterElement.Name) {
            let filterTier = new GeneralFilterTier(filterElement.Thing, filterElement.Name, filterElement.ID, filterElement.Count, this.filter, this.filterGroup, this.elementIdPrefix, this);
           
            const fieldComparator = (field) =>
                (a, b) => a[field].localeCompare(b[field], "en", {numeric: true, sensitivity: 'base'});

            let sortField = Object.hasOwn(filterElement[multiTierField][0], "ID") ? "ID" : "Name";
            filterTier.elements = filterElement[multiTierField].sort(fieldComparator(sortField)).map(element => new GeneralFilterTierElement(this.filter, element.ID ?? element.Thing, element.Count, this.elementIdPrefix, element.Name, this));
            this.elements.push(filterTier);
        }
        return this;
    }

    addFilterToPage() {
        if (this.multiTierField) {
            this.addFilterTiersToPage().addBatchFilterControlAction().addFilterSubgroupToggleAction();
        } else {
            this.addFilterElementsToPage().addBatchFilterControlAction().addFilterSubgroupToggleAction();
        }
        return this;
    }

    addFilterTiersToPage() {
        const filterHolder = document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filter-tier-holder[filter='${this.filter}']`);
        this.elements.forEach(tier => filterHolder.appendChild(tier.addFilterTierToPage()));
        return this;
    }

    addFilterElementsToPage(filterHolder) {
        if (!filterHolder) {
            filterHolder = document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControlTable tbody[filter='${this.filter}']`);
        }
        this.elements.forEach(filterElement =>  filterHolder.appendChild(filterElement.addFilterToPage()));
        return this;
    }

    // Create a new director and save it in the collection
    newFilterElement(code, count, name) {
        let filterElement = new GeneralFilterElement(this.filter, code, count, this.elementIdPrefix, name, this);
        this.elements.push(filterElement);
        return filterElement;
    }

    removeInderminateStates(selectedCode) {
        let filterHolder = document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControlTable tbody[filter='${this.filter}'], #${this.elementIdPrefix}filterControlsHolder .filter-tier-holder[filter='${this.filter}']`);
        if (filterHolder.querySelector("input:indeterminate")) {
            this.elements.forEach(filterElement => filterElement.removeInderminateState(selectedCode));
        }
        return this;
    }

    updateActiveFilterElementsTotal() {
        let filterGroupTotalHolder;
        if (this.filterGroup && (filterGroupTotalHolder = document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControl[filtergroup=${this.filterGroup}] .total`))) {
            filterGroupTotalHolder.innerHTML = (this.multiTierField) ? this.formatMultiTierFilterElementsTotal() : this.formatActiveFilterElementsTotal();
        } else {
            document.querySelector(`.total[data-filter='CompanyStatuses']`).innerHTML = this.formatActiveFilterElementsTotal();
        }
        if (this.filter == "GrowthStages") {
            this.updateCombinedFilterTotal();
        }
        if (this.filter == "FundingRoundTypes") {
            this.parent.parent.financialFilters.updateFinancialFiltersTotal();
        }
        this.removePresetStyleFromFilterControl();
        this.parent.parent.checkForFiltersUpdate();
        return this;
    }

    updateCombinedFilterTotal() {
        let element = document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .combinedFiltersTotal[data-filtergroup='company_growth']`);
        // Filter is on or off
        element.dataset[`filterstatus_${this.filter}`] = (this.addFilterToQuery()) ? 1 : 0;
        // Combine filters into total for the filter group. Value is linked to total attribute
        element.dataset.total = Object.entries(element.dataset).reduce((accumalator, entry) => accumalator + ((entry[0].startsWith('filterstatus')) ? Number(entry[1]) : 0), 0);
    }

    formatActiveFilterElementsTotal() {
        let activeFilterElementsTotal, filterElementsTotal;
        activeFilterElementsTotal = this.elements.filter(element => element.checked == true).length;
        filterElementsTotal = this.elements.length;
        return (activeFilterElementsTotal == filterElementsTotal) ? "All" : activeFilterElementsTotal;
    }

    formatMultiTierFilterElementsTotal() {
        return this.elements.flatMap(tier => tier.elements.filter(tierElement => tierElement.checked)).length;
    }

    addBatchFilterControlAction() {
        const filterGroup = this;
        document.querySelector(`#${this.elementIdPrefix}checkbox-${this.filter}-batch`).addEventListener("change", function (e) {
            filterGroup.onBatchFilterChange(this);
        });
        return this;
    }

    addFilterSubgroupToggleAction() {
        const filterGroup = this;
        let filterSubgroupToggle;
        if (filterSubgroupToggle = document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterSubheading[filter='${this.filter}']`)) {
            filterSubgroupToggle.addEventListener("click", function (e) {
                filterGroup.filterSubgroupToggleClick(this);
            });
        }
        return this;
    }

    filterSubgroupToggleClick() {
        const filterObject = this;
        let currentActiveFilter;
        if (this.filterActive == false) {
            if (currentActiveFilter = this.parent.filters.find(filter => (filter.filterActive == true && filter.filterGroup == filterObject.filterGroup))) {
                currentActiveFilter.hideFilterGroup();
            }
            this.showFilterGroup();
        }
        return this;
    }

    hideFilterGroup() {
        this.filterActive = false;
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterSubheading.filterActive[filter='${this.filter}']`).classList.remove("filterActive");
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControlTable.filterControlTableActive[filter='${this.filter}'][filtergroup='${this.filterGroup}']`).classList.remove("filterControlTableActive");
        return this;
    }

    showFilterGroup() {
        this.filterActive = true;
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterSubheading[filter='${this.filter}']`).classList.add("filterActive");
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControlTable[filter='${this.filter}']`).classList.add("filterControlTableActive");
        if(this.filter == 'SearchPostcode') {
            document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControlHolder[filtergroup='locations'] .update-filters-bar .search-wrapper`).classList.add("hidden");
        } else {
            document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControlHolder[filtergroup='locations'] .update-filters-bar .search-wrapper`).classList.remove("hidden");
        }
        this.clearPreviousFilterSearches().updateActiveFilterElementsTotal();
        return this;
    }

    onBatchFilterChange(element) {
        let state = element.checked;
        this.removeInderminateStates();
        this.elements.forEach(filterElement => filterElement.filterElementBatchUpdate(state));
        this.updateActiveFilterElementsTotal();
        return this;
    }

    isFilterValid(code) {
        return (code != undefined && code.trim().length > 0);
    }

    // Active filters if at least one element turned on but not all elements on
    addFilterToQuery() {
        let elements = this.multiTierField ? this.elements.flatMap(tier => tier.elements) : this.elements; // Get all individual filter elements
        return (this.filterActive && elements.find(filterElement => (this.partialDataset || !filterElement.filterTurnedOn())) && elements.find(filterElement => filterElement.filterTurnedOn()));
    }

    getActiveFilters() {
        const activeFilters = {};
        // Filter is currently active and at least one element is turned off
        if (this.addFilterToQuery()) {
            if (this.multiTierField) {
                activeFilters[this.queryField] = this.elements.flatMap(tier => tier.elements.flatMap(tierElement => tierElement.checked ? [tierElement.code] : []));
            } else {
                activeFilters[this.queryField] = this.elements.filter(filterElement => filterElement.filterTurnedOn()).map(filterElement => filterElement.code);
            }
        }

        return activeFilters;
    }

    // Return names of all active filters
    getActiveFilterNames() {
        const activeFilterNames = this.elements.flatMap((element) => {
            return (element.filterTurnedOn()) ? [element.name ?? element.code] : [];
        });
        return activeFilterNames;
    }

    resetFilter() {
        let searchWrapper;
        if (this.filterHasBeenUpdated()) {
            let totalFilterElements = this.elements.length;
            for (var i = 0; i < totalFilterElements; i++) {
                this.elements[i].resetFilterElement();
            }
            //this.elements.forEach(filterElement => filterElement.resetFilterElement());
            this.resetBatchFilterControl().resetFilterElements();
        }
        if (this.filterActive) {
            this.updateActiveFilterElementsTotal();
            this.parent.filterSearchReset(this.filterGroup);
            if (searchWrapper = document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .search-wrapper form[filtergroup='${this.filterGroup}']`)) {
                searchWrapper.reset();
            }
        }
    }

    clearPreviousFilterSearches() {
        this.parent.filterSearchReset(this.filterGroup);
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .search-wrapper form[filtergroup='${this.filterGroup}']`).reset();
        return this;
    }

    filterHasBeenUpdated() {
        return (!document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControlTable tbody[filter='${this.filter}'] input:indeterminate`));
    }

    resetBatchFilterControl() {
        let control;
        if(control = document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControlTable .batchFilterControl[filter='${this.filter}'] input, #${this.elementIdPrefix}filterControlsHolder .filterControlTable[filter='${this.filter}'] .filter-tier-batch-holder input[type="checkbox"]`)) {
            control.checked = false;
        }
        return this;
    }

    resetFilterElements() {
        let filterElements, totalFilterElements;
        filterElements = document.querySelectorAll(`#${this.elementIdPrefix}filterControlsHolder .filterControlTable tbody[filter='${this.filter}'] input`);
        totalFilterElements = filterElements.length;
        for (var i = 0; i < totalFilterElements; i++) {
            filterElements[i].checked = false;
            filterElements[i].indeterminate = true;
        }
    }

    presetGeneralFilter(activeFilterElements) {
        let totalFilterElements, filterControl;

        if (this.multiTierField) {
            const activeTiers = this.elements.flatMap(tier => tier.elements.find(tierElement => activeFilterElements.includes(tierElement.code)) ? [tier] : []);
            activeTiers.forEach(tier => tier.presetGeneralFilterTier(activeFilterElements));
        } else {
            totalFilterElements = this.elements.length;
            for (var i = 0; i < totalFilterElements; i++) {
                if (activeFilterElements.indexOf(this.elements[i].code) > -1) {
                    this.elements[i].presetFilter(true);
                } else {
                    this.elements[i].presetFilter(false);
                }
            }
        }

        return this;
    }

    addPresetStyleToFilterControl() {
        let filterControl;
        if (filterControl = document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .controlHolder[filtergroup='${this.filterGroup}']`)) {
            filterControl.classList.add("filterPreset");
        }
        if (this.filter == "GrowthStages") {
            document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControl[filtergroup='company_growth']`).classList.add("filterPreset");
        }
        if (this.filter == "FundingRoundTypes") {
            document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControl[filtergroup='financials']`).classList.add("filterPreset");
        }
        return this;
    }

    removePresetStyleFromFilterControl() {
        let filterControl;
        if (filterControl = document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .controlHolder[filtergroup='${this.filterGroup}']`)) {
            filterControl.classList.remove("filterPreset");
        }
        if (this.filter == "GrowthStages") {
            document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControl[filtergroup='company_growth']`).classList.remove("filterPreset");
        }
        if (this.filter == "FundingRoundTypes") {
            document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControl[filtergroup='financials']`).classList.remove("filterPreset");
        }
        return this;
    }

}

class PostcodeGeneralFilter extends GeneralFilter  {
    searchPostcode;
    searchPostcodeRadius;
    defaultSearchRadius = 10000;

    constructor(filter, filterGroup, queryField, legacyField, elementIdPrefix, parent, multiTierFilter, partialDataset, filterLabel) {
        super(filter, filterGroup, queryField, legacyField, elementIdPrefix, parent, multiTierFilter, partialDataset, filterLabel);
        this.addEventsToPostcodeControls();
    }

    setPostcodeSearchFilter(value) {
        if (document.getElementById(`${this.elementIdPrefix}postcodeSearchInput`)) {
            document.getElementById(`${this.elementIdPrefix}postcodeSearchInput`).value = value ? value.toUpperCase() : value;
            this.searchPostcode = value;
        }
        return this;
    }

    setPostcodeSearchRadiusFilter(value) {
        if (document.getElementById(`${this.elementIdPrefix}postcodeSearchRadiusSelect`)) {
            document.getElementById(`${this.elementIdPrefix}postcodeSearchRadiusSelect`).value = parseInt(value);
            this.searchPostcodeRadius = parseInt(value);
        }
        return this;
    }

    addEventsToPostcodeControls() {
        let searchRadiusElement = document.getElementById(`${this.elementIdPrefix}postcodeSearchRadiusSelect`);
        let searchInputElement = document.getElementById(`${this.elementIdPrefix}postcodeSearchInput`);
        if (searchRadiusElement) {
            this.searchPostcodeRadius = searchRadiusElement.value;
            searchRadiusElement.addEventListener("change", (event) => this.searchRadiusOnChange(event.target));
        }
        if (searchInputElement) {
            searchInputElement.addEventListener("change", (event) => this.searchInputOnChange(event.target));
        }
        return this;
    }

    searchInputOnChange(element) {
        if (element.value.length) {
            element.value = element.value.toUpperCase();
            this.searchPostcode = element.value;
        } else {
            this.searchPostcode = null;
        }
        this.updateActiveFilterElementsTotal();
        return this;
    }
    
    searchRadiusOnChange(element) {
        this.searchPostcodeRadius = parseInt(element.value);
        return this;
    }

    getActiveFilters() {
        let activeFilters = super.getActiveFilters();
        if (this.searchPostcode) {
            activeFilters["SearchPostcode"] = this.searchPostcode;
            activeFilters["SearchPostcodeRadius"] = this.searchPostcodeRadius;
        }
        return activeFilters;
    }

    formatMultiTierFilterElementsTotal() {
        let activeFiltersCount = super.formatMultiTierFilterElementsTotal();
        activeFiltersCount += this.searchPostcode ? 1 : 0;
        return activeFiltersCount;
    }

    resetFilter() {
        super.resetFilter();
        this.setPostcodeSearchFilter(null);
        this.setPostcodeSearchRadiusFilter(this.defaultSearchRadius);
        this.updateActiveFilterElementsTotal();
    }

}

class GeneralFilterElement {
    constructor(filter, code, count, elementIdPrefix, name, parent) {
        this.filter = filter;
        this.code = code;
        this.count = count;
        this.name = name ?? this.addSicDescription();
        this.elementIdPrefix = elementIdPrefix;
        this.parent = parent;
        this.checked = !this.parent.partialDataset ? true : false; // If filter field does not cover full dataset, filter element should be off by default
    }

    addFilterToPage() {
        let row, control;
        const filterElementObject = this;

        row = coreFunctions.createElementHelper("tr", { code: this.code }); // Table row
        control = coreFunctions.createElementHelper("td", { class: "filterControl" });
        row.appendChild(control);
        control.appendChild(coreFunctions.createElementHelper("input", { type: "checkbox", id: `${this.elementIdPrefix}checkbox-${this.filter}-${this.code}`, name: this.code, checked: false, indeterminate: true }, { change: function (e) { filterElementObject.filterCheckboxOnChange(this); } })); // Checkbox element
        control.appendChild(coreFunctions.createElementHelper("label", { for: `${this.elementIdPrefix}checkbox-${this.filter}-${this.code}`, innerHTML: `${this.getFilterElementContent()}${(this.count) ? `<span class="filterTotal"> (${this.count.toLocaleString()})</span>` : ""}` })); // Label for image

        return row;
    }

    getFilterElementContent() {
        return (this.filterDescriptionIsAvailable()) ? `<span class="filter-element-code" data-alphanumeric="${this.codeIsAlphanumeric()}" style="--characters: ${this.getCodeLength() + 1}ch;">${this.code}</span>${this.name}`: this.code;
    }

    // Check whether a description is available for the filter code. Ignore if descripion is not unique
    filterDescriptionIsAvailable() {
        return (this.name && (this.name != this.code));
    }

    getCodeLength() {
       return this.code.toString().length;
    }

    // Check code is a combination if letters followed by a number. Used to align codes in filter controls
    codeIsAlphanumeric() {
        const re = new RegExp("[A-Za-z][0-9]");
        return re.test(this.code);
    }

    filterElementSearch(searchString) {
		const numericalTest = new RegExp("^[0-9]+$");
        searchString = searchString.toLowerCase();
        // Test for numerical codes (e.g. SICs), use starts with for matching in this case
        if (numericalTest.test(searchString) && this.code.startsWith(searchString)) {
            this.displayFilterElement();
        } else if ((!numericalTest.test(searchString) && this.code.toLowerCase().includes(searchString)) || (this.name && this.name.toLowerCase().includes(searchString))) {
            this.displayFilterElement();
        } else {
            this.hideFilterElement();
        }
    }

    displayFilterElement() {
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControlTable[filter=\"${this.filter}\"] tr[code=\"${this.code}\"]`).classList.remove("hidden");
    }

    hideFilterElement() {
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControlTable[filter=\"${this.filter}\"] tr[code=\"${this.code}\"]`).classList.add("hidden");
    }

    addSicDescription() {
        let sicDescription, sicDescriptionSearch = null;
        if (this.filter.includes("SIC")) {
            sicDescriptionSearch = sicCodes.find(entry => entry.code == this.code);
            if (sicDescriptionSearch) {
                sicDescription = sicDescriptionSearch.description;
            }
        }
        return sicDescription;
    }

    presetFilter(state) {
        let filterElement = this.inputElement ?? document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControlTable[filter=\"${this.filter}\"] .filterControl input[name=\"${this.code}\"], #${this.elementIdPrefix}filterControlsHolder .filter-tier-holder[filter=\"${this.filter}\"] .filter-tier-elements-holder input[value=\"${this.code}\"]`);
        if (filterElement) {
            this.checked = state;
            filterElement.checked = state;
            filterElement.indeterminate = false;
        }
        return this;
    }

    filterCheckboxOnChange(element) {
        let filtersCollection;
        const filterElementObject = this;
        filterElementObject.checked = element.checked;
        this.parent.removeInderminateStates(this.code).updateActiveFilterElementsTotal();
        return this;
    }

    removeInderminateState(selectedCode) {
        if (this.code != selectedCode) {
            this.checked = false;
            document.getElementById(`${this.elementIdPrefix}checkbox-${this.filter}-${this.code}`).indeterminate = false;
        }
    }

    filterElementBatchUpdate(state) {
        let inputElement, rowElement;
        inputElement = document.getElementById(`${this.elementIdPrefix}checkbox-${this.filter}-${this.code}`);
        if ((rowElement = inputElement.closest("tr")) && rowElement.classList.contains('hidden')) {
            state = false;
        }
        this.checked = state;
        inputElement.checked = state;
    }

    filterTurnedOn() {
        return this.checked;
    }

    resetFilterElement() {
        // let filterElement = document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControlTable[filter=\"${this.filter}\"] tr[code=\"${this.code}\"] .filterControl input`);
        this.checked = !this.parent.partialDataset ? true : false;
        // filterElement.checked = false;
        // filterElement.indeterminate = true;
    }
}

class FinancialFilters {
    constructor(elementIdPrefix, parent) {
        this.elementIdPrefix = elementIdPrefix;
        this.parent = parent;
        this.PRE_TAX_PROFIT = new FinancialFilter("PRE_TAX_PROFIT", "PTP_MIN", "PTP_MAX", 1, null, elementIdPrefix, "pre tax profit", "currency");
        this.PROFIT_AFTER_TAX = new FinancialFilter("PROFIT_AFTER_TAX", "PAT_MIN", "PAT_MAX", 1, null, elementIdPrefix, "profit after tax", "currency");
        this.CASH = new FinancialFilter("CASH", "CASH_MIN", "CASH_MAX", 1, null, elementIdPrefix, "cash", "currency");
        this.TOTAL_CURRENT_ASSETS = new FinancialFilter("TOTAL_CURRENT_ASSETS", "TCA_MIN", "TCA_MAX", 1, null, elementIdPrefix, "total current assets", "currency");
        this.TOTAL_ASSETS = new FinancialFilter("TOTAL_ASSETS", "TA_MIN", "TA_MAX", 1, null, elementIdPrefix, "total assets", "currency");
        this.TOTAL_LIABILITIES = new FinancialFilter("TOTAL_LIABILITIES", "TL_MIN", "TL_MAX", 1, null, elementIdPrefix, "total liabilities", "currency");
        this.SHAREHOLDER_FUNDS = new FinancialFilter("SHAREHOLDER_FUNDS", "SF_MIN", "SF_MAX", 1, null, elementIdPrefix, "shareholder funds", "currency");
        this.NET_WORTH = new FinancialFilter("NET_WORTH", "NW_MIN", "NW_MAX", 1, null, elementIdPrefix, "net worth", "currency");
        this.ESTTURNOVER = new FinancialFilter("ESTTURNOVER", "ESTTURNOVER_MIN", "ESTTURNOVER_MAX", 1, null, elementIdPrefix, "estimated turnover", "currency");
        this.ESTEMPLOYEES = new FinancialFilter("ESTEMPLOYEES", "ESTEMPLOYEES_MIN", "ESTEMPLOYEES_MAX", 1, null, elementIdPrefix, "estimated employees", "numerical");
        this.DEALROOM = new FinancialFilter("DEALROOM", "MinDealroom", "MaxDealroom", 1000000, null, elementIdPrefix, "Dealroom funding", "currency");
        this.EXPORT = new FinancialFilter("EXPORT", "EXPORT_MIN", "EXPORT_MAX", 1, null, elementIdPrefix, "Export costs", "currency");
        this.EBITDA = new FinancialFilter("EBITDA", "EBITDA_MIN", "EBITDA_MAX", 1, null, elementIdPrefix, "EBITDA", "currency");
        this.InnovateUKFunding = new FinancialFilter("InnovateUKFunding", "InnovateUKFunding_MIN", "InnovateUKFunding_MAX", 1, null, elementIdPrefix, "Innovate UK funding", "currency");
        this.BestGrowth = new FinancialFilter("BestGrowth", "MinGrowthRate", "MaxGrowthRate", 100, "company_growth", elementIdPrefix, "company growth", "percent");
    }

    financialFilterEntered(element) {
        let field = element.getAttribute("field");
        if (element.getAttribute("boundary") == "min") {
            this[field].minValueEntered(element);
        } else {
            this[field].maxValueEntered(element);
        }
        return this;
    }

    getHumanReadableFilterChunks() {
        return Object.values(this).filter(element => element.constructor.name === 'FinancialFilter').flatMap(element => {
            const chunk = element.getHumanReadableFilterChunk();
            return chunk ? [chunk] : [];
        });
    }

    financialFilterInput(element) {
        let holder = element.closest(".financialFiltersContent");
        holder.classList.remove("filterInvalid");
        return this;
    }

    presetFinancialFilter(element, financialValue) {
        let field = element.getAttribute("field");
        if (!element.closest(".financialFiltersControl").classList.contains("hidden")) {
            element.value = financialValue * this[field].scalingFactor;
            this.financialFilterEntered(element).updateFinancialFiltersTotal(true).addPresetStyleToFilterControl(this[field]);
        }
    }

    addPresetStyleToFilterControl(filter) {
        if (filter.filterGroupParent) {
            document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .controlHolder[filtergroup='${filter.filterGroupParent}`).classList.add("filterPreset");
        } else {
            document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .controlHolder[filtergroup='financials']`).classList.add("filterPreset");
        }

        return this;
    }

    removePresetStyleFromFilterControl(filter) {
        if (filter.filterGroupParent) {
            document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .controlHolder[filtergroup='${filter.filterGroupParent}']`).classList.remove("filterPreset");
        } else {
            document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .controlHolder[filtergroup='financials']`).classList.remove("filterPreset");
        }
        return this;
    }

    removePresetStyleFromFilterGroupParent(field) {
        let filter;
        if (filter = this[field]) {
            document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .controlHolder[filtergroup='${filter.filterGroupParent}']`).classList.remove("filterPreset");
        }
    }

    updateFinancialFiltersTotal(presetFilters) {
        let activeFinancialFilters = 0;
        for (const filter in this) {
            if (this[filter].constructor.name === 'FinancialFilter') {
                activeFinancialFilters += this[filter].getActiveFiltersTotal();
                this[filter].updateFilterParentGroupState();
                // Don't change style if filters are being set on load
                if (presetFilters !== true) {
                    this.removePresetStyleFromFilterControl(this[filter]);
                }
            }
        }
        activeFinancialFilters += document.querySelectorAll('.filterControlsHolder .financialFiltersControl [filtergroup="funding_round"] tbody[filter="FundingRoundTypes"] input:checked').length > 0 ? 1 : 0;
        document.querySelector('.filterControl[filtergroup="financials"] .total').innerHTML = activeFinancialFilters;
        this.parent.checkForFiltersUpdate();

        return this;
    }

    getActiveFinancialFilters() {
        const activeFinancialFilters = {};
        for (const filter in this) {
            if (this[filter].constructor.name === 'FinancialFilter') {
                Object.assign(activeFinancialFilters, this[filter].getActiveFilterValues());
            }
        }
        return activeFinancialFilters;
    }

    filterSubgroupToggleClick(element) {
        if (!element.classList.contains("filterActive")) {
            if (element.getAttribute("filter") == "funding") {
                this.fundingFiltersActive();
            } else {
                this.financeFiltersActive();
            }
        }
        return this;
    }

    financeFiltersActive() {
        this.hideFilter("funding");
        this.showFilter("finances");
        this.activeField = "finances";
        return this;
    }

    fundingFiltersActive() {
        this.hideFilter("finances");
        this.showFilter("funding");
        this.activeField = "funding";
        return this;
    }

    hideFilter(filter) {
        let activeFilter;
        if (activeFilter = document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterSubheading.filterActive[filter='${filter}']`)) {
            activeFilter.classList.remove("filterActive");
            document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControlTable.filterControlTableActive[filter='${filter}'][filtergroup='financials']`).classList.remove("filterControlTableActive");
        }
        return this;
    }

    showFilter(filter) {
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterSubheading[filter='${filter}']`).classList.add("filterActive");
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControlTable[filter='${filter}']`).classList.add("filterControlTableActive");
        return this;
    }

    resetFinancialFilters() {
        for (const filter in this) {
            if (this[filter].constructor.name === 'FinancialFilter') {
                this[filter].resetFilter();
            }
        }
        this.updateFinancialFiltersTotal();
        return this;
    }
}

class FinancialFilter {
    constructor(field, minField, maxField, scalingFactor, filterGroupParent, elementIdPrefix, name, dataType) {
        this.field = field;
        this.valid = false;
        this.min = {
            field: minField,
            value: null
        };
        this.max = {
            field: maxField,
            value: null
        };
        this.scalingFactor = scalingFactor;
        this.filterGroupParent = filterGroupParent; // Filter is combined with several other types into a larger group.
        this.elementIdPrefix = elementIdPrefix;
        this.name = name;
        this.dataType = dataType;
    }

    filterPresetDefaultChange(element) {
        let selectedOption = element.options[element.selectedIndex];
        this.setPresetDefault("min", selectedOption.dataset.min ?? "");
        this.setPresetDefault("max", selectedOption.dataset.max ?? "");
    }

    getHumanReadableFilterChunk() {
        let content = "";
        if (this.valid) {
            let formattedMinValue = this.formatValue(this.min.value);
            let formattedMaxValue = this.formatValue(this.max.value);
            if (formattedMinValue && formattedMaxValue) {
                content += `where ${this.name} is between ${formattedMinValue} and ${formattedMaxValue}`;
            } else if (formattedMinValue) {
                content += `where ${this.name} is greater than or equal to ${formattedMinValue}`;
            } else if (formattedMaxValue) {
                content += `where ${this.name} is less than or equal to ${formattedMaxValue}`;
            }
        }
        return content;
    }

    formatValue(value) {
        if (value) {
            value *= this.scalingFactor;
            switch (this.dataType) {
                case "currency":
                    value = (new Intl.NumberFormat('en-EN', { style: 'currency', maximumFractionDigits: 0, currency: 'GBP' })).format(value);
                    break;
                case "percent":
                    value = (new Intl.NumberFormat('en', { style: 'percent', minimumSignificantDigits: 2})).format(value / 100);
                    break;
                default:
                    value = value.toLocaleString();
            }
        }
        return value;
    }

    setPresetDefault(boundary, value) {
        let filterElement;
        if (filterElement = document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .financialFiltersInput input[data-field='${this.field}'][boundary='${boundary}']`)) {
            filterElement.value = parseInt(value);
            const changeEvent = new Event('change');
            filterElement.dispatchEvent(changeEvent);
        }
    }

    minValueEntered(element) {
        this.min.value = (element.value.toString().length > 0) ? Number(element.value) / this.scalingFactor : null;
        if (!this.min.value || !this.max.value || this.min.value < this.max.value) {
            this.filterValidationSuccess(element);
        } else {
            this.filterValidationFailed(element, "The minimum value must be smaller than the maximum value.");
        }
    }

    maxValueEntered(element) {
        this.max.value = (element.value.toString().length > 0) ? Number(element.value) / this.scalingFactor : null;
        if (!this.max.value || !this.min.value || this.max.value > this.min.value) {
            this.filterValidationSuccess(element);
        } else {
            this.filterValidationFailed(element, "The maximum value must be larger than the minimum value.");
        }
    }

    filterValidationFailed(element, message) {
        this.valid = false;
        let holder = element.closest(".financialFiltersContent");
        holder.classList.add("filterInvalid");
        holder.querySelector(".financialFilterWarning").innerHTML = message;
    }

    updateFilterParentGroupState() {
        if (this.filterGroupParent) {
            let element = document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .combinedFiltersTotal[data-filtergroup='${this.filterGroupParent}']`);
            // Filter is on or off
            element.dataset[`filterstatus_${this.field}`] = (this.min.value || this.max.value) ? 1 : 0;
            // Combine filters into total for the filter group. Value is linked to total attribute
            element.dataset.total = Object.entries(element.dataset).reduce((accumalator, entry) => accumalator + ((entry[0].startsWith('filterstatus')) ? Number(entry[1]) : 0), 0);
        }
    }

    filterValidationSuccess(element) {
        this.valid = true;
        element.closest(".financialFiltersContent").classList.remove("filterInvalid");
    }

    getActiveFiltersTotal() {
        return (this.filterGroupParent) ? 0 : ((this.min.value) ? 1 : 0) + ((this.max.value) ? 1 : 0); // If part of a larger parent group of filters ignore from Financial filters total
    }

    getActiveFilterValues() {
        if (this.valid == true) {
            const activeFilterValues = {};
            const minFilterValue = {}
            const maxFilterValue = {};

            if (this.min.value) {
                minFilterValue[this.min.field] = this.min.value;
                Object.assign(activeFilterValues, minFilterValue);
            }
            if (this.max.value) {
                maxFilterValue[this.max.field] = this.max.value;
                Object.assign(activeFilterValues, maxFilterValue);
            }
            return activeFilterValues;
        } else {
            return false;
        }
    }

    resetFilter() {
        let filterPresetDefaultSelect;
        this.min.value = null;
        this.max.value = null;
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .financialFiltersInput input[name='${this.min.field}']`).value = null;
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .financialFiltersInput input[name='${this.max.field}']`).value = null;
        // If preset values available reset element to default state
        if (filterPresetDefaultSelect = document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterPresetDefaultSelect[data-field='${this.field}']`)) {
            filterPresetDefaultSelect.value = "off";
        }

    }
}

class InnovationScoreFilter {
    constructor(elementIdPrefix, parent) {
        this.filter = "innovation";
        this.minimumScore = -1;
        this.filterGroup = "company_growth";
        this.elementIdPrefix = elementIdPrefix;
        this.slider = null;
        this.parent = parent;
        this.valueToStarRating = {
            "-1": 0,
            "0": 1,
            "1.5": 2,
            "3": 3
        }
    }

    createSlider() {
        const self = this;
        this.slider = document.getElementById(this.elementIdPrefix + "innovationScoreSlider");
        let options = {
            start: [-1],
            connect: 'upper',
            range: {
                'min': -1,
                '33.3333%': 0,
                '66.6666%': 1.5,
                'max': 3
            },
            snap: true,
            pips: {
                mode: 'steps',
                density: 100,
                format: {to: function(value, type) {return self.formatSliderPips(value)}}
            }
        }

        noUiSlider.create(this.slider, options);
        this.slider.noUiSlider.on("change", function (values, handle) {self.onSliderChange(values[handle])});
        return this;
    }

    getHumanReadableFilterChunk() {
        let chunk = [];
        let starRating;
        if (starRating = this.valueToStarRating[this.minimumScore]) {
            chunk.push(`with a minimum innovation score rating of ${starRating} ${coreFunctions.pluraliseWord("star", "stars", starRating)}`);
        }
        return chunk;
    }

    onSliderChange(value) {
        this.minimumScore = Number(value);
        this.removePresetStyleFromInnovationScoreFilterControl().updateFilterGroupTotal();
        this.parent.checkForFiltersUpdate();
        return this;
    }

    updateFilterGroupTotal() {
        let element = document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .combinedFiltersTotal[data-filtergroup='${this.filterGroup}']`);
        // Filter is on or off
        element.dataset[`filterstatus_${this.filter}`] = (this.filterIsActive()) ? 1 : 0;
        // Combine filters into total for the filter group. Value is linked to total attribute
        element.dataset.total = Object.entries(element.dataset).reduce((accumalator, entry) => accumalator + ((entry[0].startsWith('filterstatus')) ? Number(entry[1]) : 0), 0);
    }

    formatSliderPips(value) {
        let filledStar = `<img src="${urlPath}/images/star-filled-white.svg">`;
        let emptyStar = `<img src="${urlPath}/images/star-outline-gray.svg">`;
        if (value == -1) {
            return "ALL";
        } else if (value == 0) {
            return `${filledStar}${emptyStar}${emptyStar}`;
        } else if (value == 1.5) {
            return `${filledStar}${filledStar}${emptyStar}`;
        } else if (value == 3) {
            return `${filledStar}${filledStar}${filledStar}`;
        }
        return this;
    }

    resetInnovationScoreFilter() {
        this.resetSlider().onSliderChange(Number(document.getElementById(this.elementIdPrefix + "innovationScoreSlider").noUiSlider.get()))
        return this;
    }

    resetSlider() {
        document.getElementById(this.elementIdPrefix + "innovationScoreSlider").noUiSlider.reset();
        return this;
    }

    presetInnovationScoreFilter(value) {
        let slider;
        if (slider = document.getElementById(this.elementIdPrefix + "innovationScoreSlider")) {
            slider.noUiSlider.set(value);
            this.onSliderChange(Number(slider.noUiSlider.get())).addPresetStyleToInnovationScoreFilterControl();
        }
        return this;
    }

    addPresetStyleToInnovationScoreFilterControl() {
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControl[filtergroup='${this.filterGroup}']`).classList.add("filterPreset");
        return this;
    }

    removePresetStyleFromInnovationScoreFilterControl() {
        document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControl[filtergroup='${this.filterGroup}']`).classList.remove("filterPreset");
        return this;
    }

    getInnovationScoreFilter() {
        if (this.minimumScore === -1) {
            return false;
        } else {
            return {
                Innovation_MIN: this.minimumScore
            }
        }
    }

    filterIsActive() {
        return this.minimumScore !== -1;
    }
}

class BooleanFilters {
    constructor(elementIdPrefix, parent) {
        this.elementIdPrefix = elementIdPrefix;
        this.parent = parent;
        this.filters = {
            OnlyCompaniesWithRegisteredAddressWithinFilterLocation: new BooleanFilter('registeredAddressOnly', 'OnlyCompaniesWithRegisteredAddressWithinFilterLocation', elementIdPrefix, this, "companies with a registered address within selected locations"),
            NotKnownToBeForeign: new BooleanFilter('notKnownToBeForeign', 'NotKnownToBeForeign', elementIdPrefix, this, "companies that are UK based"),
            OnlyCompaniesWithRegisteredAddressWithinFilterLocation: new BooleanFilter('registeredAddressOnly', 'OnlyCompaniesWithRegisteredAddressWithinFilterLocation', elementIdPrefix, this, "companies with a registered address within selected locations"),
            CalculateInsightsBasedOnlyOnRegisteredAddresses: new BooleanFilter('calculateInsightsBasedOnlyOnRegisteredAddresses', 'CalculateInsightsBasedOnlyOnRegisteredAddresses', elementIdPrefix, this, null),
            OECDScaleup: new BooleanFilter('oecdScaleupCheckbox', 'OECDScaleup', elementIdPrefix, this, "companies that are scaleups"),
            IsSpinOut: new BooleanFilter('universitySpinoutCheckbox', 'IsSpinOut', elementIdPrefix, this, "companies that are spinouts from universities"),
            OnlyCompaniesWithWebsites: new BooleanFilter('urlMatchedOnlyCheckbox', 'OnlyCompaniesWithWebsites', elementIdPrefix, this, "companies that have matched websites"),
            ExcludeForeignCompanies: new BooleanFilter('excludeForeignCompaniesCheckbox', 'ExcludeForeignCompanies', elementIdPrefix, this, "companies that are not foreign owned"),
            WomenLed: new BooleanFilter('womenLedCompaniesCheckbox', 'WomenLed', elementIdPrefix, this, "companies that are women led"),
            WomenFounded: new BooleanFilter('womenFoundedRadio', 'WomenFounded', elementIdPrefix, this, "companies that have a female founder", `${elementIdPrefix}founder-gender`, this.disableAnyFounderFilter),
            OnlyWomenFounded: new BooleanFilter('womenFoundedOnlyRadio', 'OnlyWomenFounded', elementIdPrefix, this, "companies that are only female founded", `${elementIdPrefix}founder-gender`, this.disableAnyFounderFilter),
            MenFounded: new BooleanFilter('menFoundedRadio', 'MenFounded', elementIdPrefix, this, "companies that have a male founder", `${elementIdPrefix}founder-gender`, this.disableAnyFounderFilter),
            OnlyMenFounded: new BooleanFilter('menFoundedOnlyRadio', 'OnlyMenFounded', elementIdPrefix, this, "companies that are only male founded", `${elementIdPrefix}founder-gender`, this.disableAnyFounderFilter),
            IncludeUnknownDealroom: new BooleanFilter('includeUnknownDealroomCheckbox', 'IncludeUnknownDealroom', elementIdPrefix, this, "companies that have unknown Dealroom data"),
            OnlyESGCompanies: new BooleanFilter('onlyESGCompanies', 'OnlyESGCompanies', elementIdPrefix, this, "companies that have ESG statements"),
            ExcludeOutliers: new BooleanFilter('excludeOutliersRadio', 'ExcludeOutliers', elementIdPrefix, this, "companies that do not have anomalous financial data", `${elementIdPrefix}company-anomalies`),
            ViewOutliers: new BooleanFilter('onlyOutliersRadio', 'ViewOutliers', elementIdPrefix, this, "companies that have anomalous financial data", `${elementIdPrefix}company-anomalies`),
            HasLightcastData: new BooleanFilter('hasLightcastDataCheckbox', 'HasLightcastData', elementIdPrefix, this, "companies that have jobs and skills data"),
            AnyActiveFounder:  new BooleanFilter('anyActiveFounder', 'AnyActiveFounder', elementIdPrefix, this, "companies with at least one active founder", null, this.disableGenderFounderFilters),
            HasExported: new BooleanFilter('hasExported', 'HasExported', elementIdPrefix, this, "companies that have data on exports"),
            HasImported: new BooleanFilter('hasImported', 'HasImported', elementIdPrefix, this, "companies that have data on imports")
        }
    }

    getHumanReadableFilterChunks() {
        return Object.values(this.filters).flatMap(element => {
            let chunk;
            return (element.checked && (chunk = element.getHumanReadableFilterChunk()))  ? [chunk] : [];
        });
    }

    resetBooleanFilterGroup(element) {
        const group = element.dataset.group;
        const filtersInGroup = Object.entries(this.filters).flatMap(element => {
            return (element[1].group && element[1].group == group) ? [element[1]] : [];
        });
        filtersInGroup.forEach(filter => filter.checkboxFilterOff());

        if(document.querySelector('.anyActiveFounder') && group == 'founder-gender' && this.filters.AnyActiveFounder.checked == false) {
            document.querySelector('.anyActiveFounder').classList.remove('filterDisabled');
        }
        this.parent.checkForFiltersUpdate();
    }

    resetBooleanFilters() {
        for (var field in this.filters) {
            this.filters[field].checkboxFilterOff();
        }
        document.querySelector('.founder-gender-filters').classList.remove('filterDisabled');
        if (document.querySelector('.anyActiveFounder')) {
            document.querySelector('.anyActiveFounder').classList.remove('filterDisabled');
        }
    }

    disableGenderFounderFilters() {
        this.parent.resetBooleanFilterGroup(document.querySelector('.reset-founder-gender'));
        if(this.checked) {
            document.querySelector('.founder-gender-filters').classList.add('filterDisabled');
        } else {
            document.querySelector('.founder-gender-filters').classList.remove('filterDisabled');
        }
    }

    disableAnyFounderFilter() {
        if (document.getElementById('anyActiveFounder')) {
            document.getElementById('anyActiveFounder').checked = false;
            this.parent.filters.AnyActiveFounder.checked = false;
            document.querySelector('.anyActiveFounder').classList.add('filterDisabled');
        }
        return this;
    }

    processStoredBooleanFilters(activeFilters) {
        for (var field in this.filters) {
            if (activeFilters.hasOwnProperty(field)) {
                this.filters[field].presetBooleanFilter(activeFilters[field]);
                if(this.filters[field].callback) {
                    this.filters[field].callback();
                }
            }
        }
    }

    getActiveBooleanFilters() {
        let checkboxFiltersForSearch = false;
        if (this.checkboxFiltersActive()) {
            checkboxFiltersForSearch = this.processActiveBooleanFiltersFields();
        }
        return checkboxFiltersForSearch;
    }

    checkboxFiltersActive() {
        return ((Object.entries(this.filters).find(element => element[1].checked === true && element[1].element.checked === true)) != undefined);
    }

    processActiveBooleanFiltersFields() {
        return Object.entries(this.filters).reduce(function(activeFilters, element) {
            if (element[1].checked) {
                // Ensure DOM element is also checked, take into account radio buttons
                if (element[1].element.checked) {
                    activeFilters[element[1].queryField] = true;
                } else {
                    element[1].checkboxFilterOff();
                }
            }
            return activeFilters;
        }, {});
    }
}

class BooleanFilter {
    constructor(field, queryField, elementIdPrefix, parent, description, group, callback) {
        this.field = field;
        this.queryField = queryField; // Field used for API query
        this.elementIdPrefix = elementIdPrefix;
        this.element = document.getElementById(`${this.elementIdPrefix}${this.field}`);
        this.checked = false;
        this.group = group; // Filters can be grouped together i.e. radio buttons
        this.addOnChangeEvent();
        this.parent = parent;
        this.description = description;
        this.callback = callback;
    }

    getHumanReadableFilterChunk() {
        let chunk;
        if (this.description) {
            chunk = this.description.startsWith("companies") ? this.description.replace("companies", "").trim() : this.description;
        }
        return chunk;
    }

    addOnChangeEvent() {
        if (this.element) {
            this.element.addEventListener("change", (event) => this.onCheckboxChange());
        }
    }

    onCheckboxChange() {
        if (this.element.checked) {
            this.checkboxFilterOn();
        } else {
            this.checkboxFilterOff();
        }
        this.parent.parent.checkForFiltersUpdate();

        if(this.callback) {
            this.callback();
        }
    }

    presetBooleanFilter(state) {
        if (this.element) {
            this.element.checked = state;
            this.checked = state;
            this.parent.parent.checkForFiltersUpdate();
        }
    }

    checkboxFilterOff() {
        if (this.element) {
            this.element.checked = false;
            this.checked = false;
        }
    }

    checkboxFilterOn() {
        if (this.element) {
            this.element.checked = true;
            this.checked = true;
        }
    }
}

class SingleOptionFilters {
    constructor(elementIdPrefix, parent) {
        this.parent = parent;
        this.elementIdPrefix = elementIdPrefix;
        this.filters = new Object();
    }

    addFilters(filters) {
        if (filters.hasOwnProperty("CompanyStatuses")) {
            const tooltip = 'For more information on how we define company statuses, as well as how we recommend using this data, please read this <a href="https://help.thedatacity.com/knowledge/company-births-and-deaths" target="_blank">article</a>';
            this.newSingleOptionFilter("CompanyStatuses", "CompanyStatus", "Company status", filters.CompanyStatuses, "Active", tooltip).createFilterElements().setFormElement();
        }
        return this;
    }

    getHumanReadableFilterChunks() {
        return Object.values(this.filters).flatMap(element => {
            const chunk = element.getHumanReadableFilterChunk();
            return chunk ? [chunk] : [];
        });
    }

    newSingleOptionFilter(field, queryField, name, elements, defaultValue, tooltip) {
        const singleOptionFilter = new SingleOptionFilter(field, queryField, name, this.elementIdPrefix, this.parent, elements, defaultValue, tooltip);
        Object.assign(this.filters, {[field]: singleOptionFilter});
        return singleOptionFilter;
    }

    hideSingleOptionFilterBarControl(filter) {
        let filterBarControl;
        if (filterBarControl = document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControl[filtergroup='${filter}']`)) {
            filterBarControl.classList.add("hidden");
        }
    }

    getActiveSingleOptionFilters() {
        const filtersObject = {};
        for (var field in this.filters) {
            Object.assign(filtersObject, this.filters[field].getActiveFilter());
        }
        return filtersObject;
    }

    resetSingleOptionFilters() {
        for (var field in this.filters) {
            this.filters[field].resetSingleOptionFilter();
        }
        return this;
    }

    // Loop through single option filters. Preset value if query field is in filters object, otherwise reset filter
    processStoredSingleOptionFilters(storedFilters) {
        for (var field in this.filters) {
            const queryField = this.filters[field].queryField;
            if (Object.hasOwn(storedFilters, queryField)) {
                this.filters[field].presetSingleOptionFilter(storedFilters[queryField]);
            } else {
                this.filters[field].clearSingleOptionFilter();
            }
        }
    }

    presetSingleOptionFilters(field, value) {
        let filter;
        if (filter = this.filter[field]) {
            filter.presetSingleOptionFilter(value);
        }
    }

    findPresetSingleOptionFilter(queryField) {
        let activeFilterEntry;
        if (activeFilterEntry = Object.entries(this.filters).find(element => element[1].queryField == queryField)) {
            return activeFilterEntry[1];
        } else {
            return false;
        }
    }

    filterSearch(searchString, filter) {
        if (Object.hasOwn(this.filters, filter)) {
            this.filters[filter].filterSearch(searchString);
        }
    }

    clearFilterSearch(element) {
        let filter;
        if (Object.hasOwn(this.filters, filter = element.dataset.filter)) {
            this.filters[filter].clearFilterSearch();
        }
    }
}

class SingleOptionFilter {
    constructor(field, queryField, name, elementIdPrefix, parent, elements, defaultValue, tooltip, ) {
        this.field = field;
        this.queryField = queryField;
        this.name = name;
        this.parent = parent;
        this.elementIdPrefix = elementIdPrefix;
        this.defaultValue = defaultValue;
        this.elements = this.processFilterElements(elements);
        this.form; // Element containing filter controls
        this.tooltip = tooltip;
    }

    getHumanReadableFilterChunk() {
        let chunk, activeElement;
        if (activeElement = this.elements.find(element => element.filterIsActive())) {
            // Ignore if still set to starting default value
            if (activeElement.thing != this.defaultValue) {
                chunk = `with a ${activeElement.name} ${this.name}`;
            }
        }
        return chunk;
    }

    processFilterElements(elements) {
        return (Array.isArray(elements) && elements.length) ? elements.map(element => new SingleOptionFilterElement(this.field, element.Thing, element.Name ?? element.Thing, element.Count, this.elementIdPrefix, (element.Thing == this.defaultValue), this)) : [];
    }

    getActiveFilter() {
        let value;
        if (!this.form) return false;
        return (value = this.form.elements[this.field].value) ? {[this.queryField] : value} : false;
    }

    setFormElement() {
        this.form =  document.querySelector(`#${this.elementIdPrefix}${this.field}SingleOptionFilterHolder form`);
        return this;
    }

    createFilterElements() {
        let holder;
        if (holder = document.getElementById(`${this.elementIdPrefix}${this.field}SingleOptionFilterHolder`)) {
            const fragment = document.createDocumentFragment();
            const title = fragment.appendChild(coreFunctions.createElementHelper("h4"));
            const name = title.appendChild(coreFunctions.createElementHelper("span"));
            if (this.tooltip) {
                name.appendChild(this.createTooltip());
            }
            name.appendChild(coreFunctions.createElementHelper("span", {innerHTML: this.name}));
            title.appendChild(coreFunctions.createElementHelper("button", {class: "actionControl reset-filter right", innerHTML: "Reset"}, {click: () => this.clearSingleOptionFilter()}));
            const form = fragment.appendChild(coreFunctions.createElementHelper("form"));
            const ul = form.appendChild(coreFunctions.createElementHelper("ul"));
            this.elements.forEach(element => ul.appendChild(element.createFilterElement()));
            holder.appendChild(fragment);
        }
        return this;
    }

    createTooltip() {
        let holder = coreFunctions.createElementHelper("span", {class: "tooltip-explanation-holder"});
        holder.appendChild(coreFunctions.createElementHelper("input", {type: "checkbox", id: `${this.field}_explanation`}));
        let label = holder.appendChild(coreFunctions.createElementHelper("label", {for: `${this.field}_explanation`}));
        label.appendChild(coreFunctions.createElementHelper("span", {class: "question-mark", innerHTML: "?"}));
        label.appendChild(coreFunctions.createElementHelper("span", {class:"tooltip-explanation", innerHTML: this.tooltip}));
        return holder;
    }

    // Clear all options
    clearSingleOptionFilter() {
        if (this.form) {
            this.form.reset();
            this.updateFilterTotalElement();
            this.parent.checkForFiltersUpdate();
        }
    }

    // Reset options, return to default settings if available
    resetSingleOptionFilter() {
        if (this.form) {
            this.form.reset();
            if (this.defaultValue) {
                this.setDefaultOption();
            }
            this.updateFilterTotalElement();
        }
        return this;
    }

    setDefaultOption() {
        let defaultElement;
        if (defaultElement = this.elements.find(element => element.isDefaultElement)) {
            this.form.elements[this.field].value = defaultElement.thing;
        }
    }

    presetSingleOptionFilter(value) {
        if (this.form) {
            this.form.elements[this.field].value = value;
            this.updateFilterTotalElement();
        }
        return this;
    }

    updateFilterTotalElement() {
        let filterTotalElement;
        if (filterTotalElement = document.querySelector(`#${this.elementIdPrefix}filterControlsHolder .filterControl[filtergroup='${this.field}'] .total`)) {
            filterTotalElement.innerHTML = this.getActiveFilter() ? 1 : 0;
        }
        return this;
    }

    filterSearch(searchString) {
        this.elements.forEach(element => element.toggleFilterElementDisplay(!element.matchesSearchString(searchString)));
    }

    clearFilterSearch() {
        this.elements.forEach(element => element.toggleFilterElementDisplay(false));
    }
}

class SingleOptionFilterElement {
    inputElement;
    constructor (field, thing, name, count, elementIdPrefix, isDefaultElement, parent) {
        this.field = field;
        this.thing = thing;
        this.name = name;
        this.count = count;
        this.elementIdPrefix = elementIdPrefix;
        this.isDefaultElement = isDefaultElement;
        this.parent = parent;
    }

    filterIsActive() {
        return this.inputElement && this.inputElement.checked;
    }

    createFilterElement() {
        const id = `${this.elementIdPrefix}${this.field}${this.thing}FilterElement`;
        const li = document.createElement("li");
        this.inputElement = li.appendChild(coreFunctions.createElementHelper("input", {type: "radio", id: id, name: this.field, value: this.thing}, {change: (event) => this.filterElementOnChange() }));
        if (this.isDefaultElement) {
            this.inputElement.checked = true;
        }
        li.appendChild(coreFunctions.createElementHelper("label", {for: id, innerHTML: `${this.name}${this.count ? ` <span class='filter-total'>(${this.count.toLocaleString()})</span>` : ""}`}));
        return li;
    }

    matchesSearchString(searchString) {
        return this.name.toLowerCase().includes(searchString);
    }

    filterElementOnChange() {
        this.parent.updateFilterTotalElement();
        this.parent.parent.checkForFiltersUpdate();
    }

    toggleFilterElementDisplay(hideElement) {
        this.inputElement.closest("li").classList.toggle("hidden", hideElement);
    }
}

class GeneralFilterTier {
    elements = [];
    inputElement;
    expandElement;

    constructor(thing, name, id, count, filter, filterGroup, elementIdPrefix, parent) {
        this.thing = thing ?? name;
        this.name = name;
        this.id = id;
        this.count = count;
        this.filter = filter;
        this.filterGroup = filterGroup;
        this.parent = parent;
        this.elementIdPrefix = elementIdPrefix;
    }

    addFilterTierToPage() {
        const filterTier = coreFunctions.createElementHelper("li", {class: "filter-tier"});
        const controlsHolder = filterTier.appendChild(coreFunctions.createElementHelper("div", {class: "filter-tier-controls flex-row-holder"}));
        controlsHolder.appendChild(this.createBatchControl());
        controlsHolder.appendChild(this.createExpandControl());

        const filterElementsHolder = filterTier.appendChild(coreFunctions.createElementHelper("ul", {class: "filter-tier-elements-holder"}));
        this.elements.forEach(element => filterElementsHolder.appendChild(element.addGeneralFilterTierElementToPage()));

        return filterTier;
    }

    createBatchControl() {
        const batchControl = coreFunctions.createElementHelper("div", {class: "batch-filter-tier-holder flex-grow"});
        const batchControlID = `${this.elementIdPrefix}_${this.filter}_${this.thing}_batchControl`;
        this.inputElement = batchControl.appendChild(coreFunctions.createElementHelper("input", {type: "checkbox", id: batchControlID, value: this.thing}, {change: (event) => this.batchControlOnChange(event.target)}));
        batchControl.appendChild(coreFunctions.createElementHelper("label", {for: batchControlID, innerHTML: this.getControlLabel(), class: "filter-batch-control-label"})).appendChild(coreFunctions.createElementHelper("span", {innerHTML: ` (${this.count.toLocaleString()})`, class: "filterTotal"}));
        return batchControl;
    }

    getControlLabel() {
        return (this.id) ? `<span class="filter-element-code" data-alphanumeric="${this.codeIsAlphanumeric()}" style="--characters: ${this.getIdLength() + 1}ch;">${this.id}</span>${this.thing}`: this.thing;
    }

    getIdLength() {
       return this.id.toString().length;
    }

    // Check code is a combination if letters followed by a number. Used to align codes in filter controls
    codeIsAlphanumeric() {
        const re = new RegExp("[A-Za-z][0-9]");
        return re.test(this.code);
    }

    createExpandControl() {
        const expandControl = coreFunctions.createElementHelper("div", {class: "expand-filter-tier-holder"});
        const expandControlID = `${this.elementIdPrefix}_${this.filter}_${this.thing}_expandControl`;
        this.expandElement = expandControl.appendChild(coreFunctions.createElementHelper("input", {type: "checkbox", id: expandControlID}));
        expandControl.appendChild(coreFunctions.createElementHelper("label", {for: expandControlID, class: "expand-filter-tier-label"}));
        return expandControl;
    }

    batchControlOnChange(control) {
        this.filterElementsBatchSet(control.checked);
        this.parent.updateActiveFilterElementsTotal();
        return this;
    }

    // Will update all tier elements
    filterElementBatchUpdate(isChecked) {
        this.inputElement.checked = isChecked;
        this.filterElementsBatchSet(isChecked); // Set state of filter tier children
        return this;
    }

    filterElementsBatchSet(isChecked) {
        this.elements.forEach(element => element.presetFilter(isChecked));
        return this;
    }

    displayFilterElement() {
        this.inputElement.closest("li").classList.toggle("hidden", false);
        return this;
    }

    // Hides the filter tier controls if it does not match the search
    filterElementSearch(searchString) {
        searchString = searchString.toLowerCase();
        const tierMatchesSearchString = this.thing.toLowerCase().includes(searchString) || (this.id && this.id.toLowerCase().startsWith(searchString));
        this.inputElement.closest("li").classList.toggle("hidden", !tierMatchesSearchString);
        // Check child elements for a match
        if (!tierMatchesSearchString && this.elements.find(element => element.matchesSearchString(searchString))) {
            // Display tier and open to see child elements
            this.inputElement.closest("li").classList.toggle("hidden", false);
            this.expandElement.checked = true;
        }
        return this;
    }

    resetFilterElement() {
        this.displayFilterElement().filterElementBatchUpdate(false);
    }

    presetGeneralFilterTier(activeFilterElements) {
        this.elements.forEach(element => element.presetFilter(activeFilterElements.includes(element.code)));
        this.inputElement.checked = this.elements.find(element => !element.checked) == undefined; // Set state of batch control to checked if all child elements are checked
        this.expandElement.checked = true; // Expand tier to show preset filters

    }

    filterTurnedOn() {
        return this.elements.find(element => element.checked) != undefined;
    }

    getActiveGeneralFilterTierElements() {
        return this.elements.flatMap(element => element.checked ? [element.name] : []);
    }

}

class GeneralFilterTierElement extends GeneralFilterElement {
    inputElement;
    constructor(filter, code, count, elementIdPrefix, name, parent) {
        super(filter, code, count, elementIdPrefix, name, parent);
        this.checked = false;
    }

    addGeneralFilterTierElementToPage() {
        const control = coreFunctions.createElementHelper("li", { code: this.code});
        this.inputElement = control.appendChild(coreFunctions.createElementHelper("input", { type: "checkbox", id: `${this.elementIdPrefix}checkbox-${this.filter}-${this.code}`, name: this.code, value: this.code, checked: false }, { change: (event) => this.filterCheckboxOnChange(event.target)})); // Checkbox element
        const label = control.appendChild(coreFunctions.createElementHelper("label", { for: `${this.elementIdPrefix}checkbox-${this.filter}-${this.code}`, class: "filter-element-label"})); // Label for image

        // Fixed width for code
        label.appendChild(coreFunctions.createElementHelper("span", {innerHTML: `${this.getFilterElementContent()}${(this.count) ? `<span class="filterTotal"> (${this.count.toLocaleString()})</span>` : ""}` }));

        return control;
    }

    matchesSearchString(searchString) {
        return this.code.toLowerCase().startsWith(searchString) || (this.name && this.name.toLowerCase().includes(searchString));
    }
}